(function () {
  'use strict';

  var ROOT_ID = 'TiltCustomizer';
  var CONFIG_ID = 'TiltCustomizerConfig';
  var CANVAS_ID = 'TiltCustomizerCanvas';
  var SESSION_KEY = 'tilt_customizer_session_id';
  var DEFAULT_MAX_FILE_BYTES = 50 * 1024 * 1024;
  var VALID_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
  var VALID_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];
  var MIN_GESTURE_TARGET_SIZE = 160;
  var MOBILE_DESELECT_TAP_MOVE_THRESHOLD = 10;
  var MOBILE_DESELECT_TAP_MAX_DURATION = 500;
  var DEFAULT_CUSTOMER_IMAGE_FIT_OVERSCAN_X = 1;
  var DEFAULT_CUSTOMER_IMAGE_FIT_OVERSCAN_Y = 1;
  var THUMBNAIL_BACKGROUND_COLOR = '#020a0a';
  var STATUS = {
    IDLE: 'idle',
    FILE_SELECTED: 'file_selected',
    UPLOADING: 'uploading',
    UPLOAD_FAILED: 'upload_failed',
    UPLOAD_COMPLETED: 'upload_completed',
    EDITING: 'editing',
    THUMBNAIL_GENERATING: 'thumbnail_generating',
    FINALIZING: 'finalizing',
    READY_FOR_CART: 'ready_for_cart',
    ADD_TO_CART_IN_PROGRESS: 'add_to_cart_in_progress',
    ADD_TO_CART_FAILED: 'add_to_cart_failed'
  };

  var TRANSLATIONS = {
    pl: {
      uploadingArtwork: 'Wgrywamy grafikę...',
      uploadAlreadyInProgress: 'Trwa wgrywanie grafiki. Poczekaj chwilę.',
      preparingPreview: 'Przygotowywanie podglądu...',
      preparingCustomization: 'Przygotowywanie personalizacji...',
      loadingCardTemplate: 'Wczytywanie szablonu...',
      cardTemplateFailed: 'Nie udało się wczytać szablonu. Poprzedni wybór został zachowany. Spróbuj ponownie.',
      processing: 'Przetwarzanie...',
      uploadArtworkBeforeCart: 'Przed zakupem dodaj grafikę.',
      uploadFailed: 'Nie udało się przesłać pliku. Spróbuj ponownie.',
      previewFailed: 'Nie udało się przygotować podglądu. Spróbuj ponownie.',
      customizationFailed: 'Nie udało się przygotować personalizacji. Spróbuj ponownie.',
      customizerProcessing: 'Personalizacja jest przetwarzana.',
      customizerFinalizeFailed: 'Nie udało się sfinalizować personalizacji.',
      addToCartFailed: 'Nie udało się dodać produktu do koszyka. Spróbuj ponownie.',
      missingTemplateConfiguration: 'Personalizacja nie jest jeszcze skonfigurowana dla tego produktu.',
      missingTemplateForVariant: 'Personalizacja nie jest jeszcze dostępna dla tego wariantu.',
      missingMockupForVariant: 'Brakuje mockupu customizera dla tego wariantu.',
      invalidFileType: 'Wgraj plik JPG, PNG albo WebP.',
      fileTooLargePrefix: 'Plik jest za duży. Maksymalny rozmiar to ',
      fileTooLargeSuffix: ' MB.',
      fileSelected: 'Plik wybrany.',
      sizeChangedUploadAgain: 'Rozmiar został zmieniony. Wgraj grafikę ponownie.',
      genericUploadProcessingFailed: 'Coś poszło nie tak. Spróbuj ponownie.'
    },
    en: {
      uploadingArtwork: 'Uploading image...',
      uploadAlreadyInProgress: 'Trwa wgrywanie grafiki. Poczekaj chwilę.',
      preparingPreview: 'Preparing preview...',
      preparingCustomization: 'Preparing your customization...',
      loadingCardTemplate: 'Loading template...',
      cardTemplateFailed: 'Could not load the template. Your previous selection was kept. Please try again.',
      processing: 'Processing...',
      uploadArtworkBeforeCart: 'Add an image before purchasing.',
      uploadFailed: 'We couldn\'t upload your file. Please try again.',
      previewFailed: 'We couldn\'t prepare your preview. Please try again.',
      customizationFailed: 'We couldn\'t prepare your customization. Please try again.',
      customizerProcessing: 'Customizer is processing.',
      customizerFinalizeFailed: 'Customizer finalize failed.',
      addToCartFailed: 'We couldn\'t add this item to your cart. Please try again.',
      missingTemplateConfiguration: 'Customization is not configured for this product yet.',
      missingTemplateForVariant: 'Customization is not available for this variant yet.',
      missingMockupForVariant: 'Customizer mockup is missing for this variant.',
      invalidFileType: 'Upload JPG, PNG or WebP file.',
      fileTooLargePrefix: 'File is too large. Maximum size is ',
      fileTooLargeSuffix: ' MB.',
      fileSelected: 'File selected.',
      sizeChangedUploadAgain: 'Size changed. Please upload your artwork again.',
      genericUploadProcessingFailed: 'Something went wrong. Please try again.'
    }
  };

  function getLocale() {
    var lang = document.documentElement && document.documentElement.lang
      ? String(document.documentElement.lang).toLowerCase()
      : '';

    return lang === 'pl' || lang.indexOf('pl-') === 0 ? 'pl' : 'en';
  }

  function t(key) {
    var locale = getLocale();

    if (!TRANSLATIONS[locale] || !Object.prototype.hasOwnProperty.call(TRANSLATIONS[locale], key)) {
      throw new Error('[TiltCustomizer] Missing translation: ' + locale + '.' + key);
    }

    return TRANSLATIONS[locale][key];
  }

  var canvas = null;
  var backendState = {
    currentDesignId: null,
    designId: null,
    finalizedDesignId: null,
    finalizedVariantId: null,
    editToken: null,
    originalAssetId: null,
    uploadedAssetId: null,
    thumbnailUrl: null,
    originalUrl: null,
    productionUrl: null,
    upscaledOriginalUrl: null,
    upscaledProductionUrl: null,
    hasUploadedArtwork: false,
    isUploading: false,
    isFinalizing: false,
    isAddToCartInProgress: false,
    isSceneLoading: false,
    isCardTemplateLoading: false,
    status: STATUS.IDLE,
    lastError: null
  };

  var config = null;
  var sessionId = null;
  var uploadStatusElement = null;
  var customizerRoot = null;
  var sceneLoadToken = 0;
  var sceneLoadPromise = null;
  var cardTemplateLoadToken = 0;
  var cardTemplateLoadPromise = null;
  var canvasWidth = null;
  var canvasHeight = null;
  var printArea = null;
  var currentVariant = null;
  var currentTemplate = null;
  var currentTemplateKey = null;
  var productCustomizerConfig = null;
  var productCustomizerConfigStatus = 'unknown';
  var resizeFrame = null;
  var canvasDisplaySignature = '';
  var variantSyncFrame = null;
  var addToCartButton = null;
  var addToCartButtonOriginalText = null;
  var addToCartButtonWasDisabled = false;
  var controlsAddToCartWasDisabled = false;
  var telemetryErrorHandlersBound = false;
  var uploadTelemetryAttemptSequence = 0;
  var activePinchGesture = null;
  var activeTouchDragGesture = null;
  var activeTouchPointers = {};
  var mobileDeselectTap = null;
  var gestureOverlay = null;
  var gestureOverlayFrame = null;
  var gestureOverlaySignature = '';
  var state = {
    cardTemplateId: null,
    cardTemplateOverlay: null,
    scene: null,
    customerImage: null,
    mockupBase: null,
    sceneLayers: []
  };

  function parseConfig() {
    var configNode = document.getElementById(CONFIG_ID);
    var parsedConfig = null;

    if (!configNode) {
      console.error('[TiltCustomizer] Config node not found.');
      return null;
    }

    try {
      parsedConfig = JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('[TiltCustomizer] Invalid config JSON.', error);
      return null;
    }

    if (!window.TiltCustomizerTemplateRegistry) {
      console.error('[TiltCustomizer] Template registry asset is not loaded.');
      return null;
    }

    parsedConfig.templateRegistry = window.TiltCustomizerTemplateRegistry;

    return parsedConfig;
  }

  function hasNumber(value) {
    return typeof value === 'number' && isFinite(value);
  }

  function isValidPrintArea(area) {
    return !!area &&
      hasNumber(area.left) &&
      hasNumber(area.top) &&
      hasNumber(area.width) &&
      hasNumber(area.height) &&
      area.width > 0 &&
      area.height > 0;
  }

  function validateConfig(customizerConfig) {
    var invalidReasons = [];

    if (!customizerConfig.templateRegistry) {
      invalidReasons.push('Missing required templateRegistry config.');
    }

    if (!customizerConfig.templateId || !customizerConfig.templateVersion) {
      invalidReasons.push('Missing active templateId/templateVersion.');
    }

    if (!customizerConfig.canvas || !hasNumber(customizerConfig.canvas.width) || !hasNumber(customizerConfig.canvas.height)) {
      invalidReasons.push('Missing required canvas.width/canvas.height.');
    }

    if (!customizerConfig.scenes || !Object.keys(customizerConfig.scenes).length) {
      invalidReasons.push('Missing required scenes config.');
    } else {
      Object.keys(customizerConfig.scenes).forEach(function (sceneId) {
        var sceneConfig = customizerConfig.scenes[sceneId];

        if (!sceneConfig) {
          invalidReasons.push('Missing required scene: ' + sceneId + '.');
          return;
        }

        if (!sceneConfig.mockupUrl) {
          invalidReasons.push('Missing required mockupUrl for scene: ' + sceneId + '.');
        }

        if (!isValidPrintArea(sceneConfig.printArea)) {
          invalidReasons.push('Missing or invalid printArea for scene: ' + sceneId + '.');
        }

        if (sceneConfig.layers && Array.isArray(sceneConfig.layers)) {
          sceneConfig.layers.forEach(function (layer, index) {
            if (!layer || !layer.url) {
              invalidReasons.push('Missing required layer url for scene: ' + sceneId + ', layer index: ' + index + '.');
            }
          });
        } else {
          sceneConfig.layers = [];
        }
      });
    }

    if (invalidReasons.length) {
      console.error('[TiltCustomizer] Invalid config:', invalidReasons);
      return false;
    }

    return true;
  }

  function getOrCreateSessionId() {
    var existingSessionId = null;

    try {
      existingSessionId = window.localStorage.getItem(SESSION_KEY);
    } catch (error) {
      console.warn('[TiltCustomizer] localStorage is unavailable.', error);
    }

    if (existingSessionId) {
      return existingSessionId;
    }

    var newSessionId = '';

    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      newSessionId = window.crypto.randomUUID();
    } else {
      newSessionId = 'tilt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }

    try {
      window.localStorage.setItem(SESSION_KEY, newSessionId);
    } catch (error) {
      console.warn('[TiltCustomizer] Could not persist session ID.', error);
    }

    return newSessionId;
  }

  function createTelemetryId(prefix) {
    var suffix = '';

    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      suffix = window.crypto.randomUUID();
    } else {
      suffix = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }

    return prefix + '_' + suffix;
  }

  function getUploadHost(url) {
    try {
      return trimTelemetryString(new URL(url, window.location.href).host, 120);
    } catch (error) {
      return null;
    }
  }

  function joinApiPath(basePath, path) {
    var normalizedBase = String(basePath || '').replace(/\/+$/, '');
    var normalizedPath = String(path || '').replace(/^\/+/, '');

    return normalizedBase + '/' + normalizedPath;
  }

  function isDebugEnabled() {
    return !!(config && config.debug === true);
  }

  function debugLog() {
    if (isDebugEnabled() && window.console && typeof window.console.debug === 'function') {
      window.console.debug.apply(window.console, arguments);
    }
  }

  function isTelemetryEnabled() {
    return !!(config && config.backendEnabled === true && config.telemetryEnabled === true);
  }

  function trimTelemetryString(value, maxLength) {
    if (value == null) {
      return null;
    }

    var normalized = String(value).trim();
    if (!normalized) {
      return null;
    }

    return normalized.length <= maxLength ? normalized : normalized.slice(0, maxLength);
  }

  function getTelemetryContext(extra) {
    var payload = {
      templateId: config && config.templateId ? String(config.templateId) : null,
      templateKey: currentTemplateKey ? String(currentTemplateKey) : null,
      templateVersion: config && config.templateVersion ? Number(config.templateVersion) : null,
      productId: config && config.productId != null ? String(config.productId) : null,
      variantId: config && config.variantId != null ? String(config.variantId) : null,
      status: backendState.status,
      language: getLocale(),
      isMobile: shouldUseCustomTouchGestures(),
      viewportWidth: window.innerWidth || null,
      viewportHeight: window.innerHeight || null,
      hasArtwork: hasUploadedArtworkForCart(),
      hasThumbnail: !!backendState.thumbnailUrl,
      hasOriginal: !!backendState.originalUrl,
      hasProduction: !!backendState.productionUrl
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        payload[key] = extra[key];
      });
    }

    return payload;
  }

  function trackTelemetryEvent(eventType, data) {
    if (!isTelemetryEnabled() || !backendState.designId || !backendState.editToken || !eventType) {
      return;
    }

    try {
      window.fetch(joinApiPath(config.apiBasePath, '/designs/' + encodeURIComponent(backendState.designId) + '/telemetry'), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          editToken: backendState.editToken,
          eventType: eventType,
          data: getTelemetryContext(data)
        }),
        keepalive: true
      }).catch(function (error) {
        debugLog('[TiltCustomizer] telemetry failed.', error);
      });
    } catch (error) {
      debugLog('[TiltCustomizer] telemetry failed.', error);
    }
  }

  function getFileTelemetryData(file) {
    return file ? {
      fileSizeBytes: file.size,
      mimeType: trimTelemetryString(file.type, 80)
    } : {};
  }

  function getErrorTelemetryData(error) {
    var data = {
      errorName: trimTelemetryString(error && error.name ? error.name : 'Error', 80),
      errorMessage: trimTelemetryString(error && error.message ? error.message : String(error || 'Unknown error'), 180)
    };

    if (error && typeof error.httpStatus === 'number') {
      data.httpStatus = error.httpStatus;
    }

    return data;
  }
  function installTelemetryErrorHandlers() {
    if (telemetryErrorHandlersBound) {
      return;
    }

    telemetryErrorHandlersBound = true;

    window.addEventListener('error', function (event) {
      var message = event && event.message ? String(event.message) : '';
      var source = event && event.filename ? String(event.filename) : '';
      var stack = event && event.error && event.error.stack ? String(event.error.stack) : '';

      if (message.indexOf('TiltCustomizer') === -1 && source.indexOf('tilt-customizer') === -1 && stack.indexOf('TiltCustomizer') === -1) {
        return;
      }

      trackTelemetryEvent('frontend_customizer_js_error', {
        source: trimTelemetryString(source, 180),
        errorName: 'Error',
        errorMessage: trimTelemetryString(message, 180)
      });
    });

    window.addEventListener('unhandledrejection', function (event) {
      var reason = event && event.reason ? event.reason : null;
      var message = reason && reason.message ? reason.message : String(reason || 'Unhandled promise rejection');
      var stack = reason && reason.stack ? String(reason.stack) : '';

      if (message.indexOf('TiltCustomizer') === -1 && stack.indexOf('TiltCustomizer') === -1) {
        return;
      }

      trackTelemetryEvent('frontend_customizer_js_error', Object.assign({ source: 'unhandledrejection' }, getErrorTelemetryData(reason)));
    });
  }
  function setCustomizerStatus(status, message, type) {
    backendState.status = status;

    if (type === 'error') {
      backendState.lastError = message || null;
    } else {
      backendState.lastError = null;
    }

    setUploadStatus(message, type);
  }

  function getMaxFileBytes() {
    return hasNumber(config && config.maxFileBytes) && config.maxFileBytes > 0
      ? config.maxFileBytes
      : DEFAULT_MAX_FILE_BYTES;
  }

  function getMaxFileMegabytes() {
    return Math.round(getMaxFileBytes() / 1024 / 1024);
  }

  function readResponsePayload(response) {
    return response.text().then(function (text) {
      var payload = null;

      if (text) {
        try {
          payload = JSON.parse(text);
        } catch (error) {
          payload = { message: text };
        }
      }

      return payload;
    });
  }

  function buildRequestError(prefix, response, payload) {
    var message = payload && (payload.error || payload.message)
      ? payload.error || payload.message
      : 'HTTP ' + response.status;

    var error = new Error(prefix + ': ' + message);
    error.httpStatus = response.status;
    return error;
  }

  function getProductCustomizerConfig(variant) {
    var registry = config && config.templateRegistry;
    var productConfig = null;
    var variantId = variant && variant.id != null ? String(variant.id) : null;

    productCustomizerConfigStatus = 'missing_registry';

    if (!registry) {
      return null;
    }

    productCustomizerConfigStatus = 'missing_product';

    if (registry.productsByVariantId && variantId && registry.productsByVariantId[variantId]) {
      productConfig = registry.productsByVariantId[variantId];
    }

    if (!productConfig || productConfig.enabled !== true) {
      productCustomizerConfigStatus = productConfig ? 'disabled_product' : 'missing_product';
      return null;
    }

    if (productConfig.productId != null && String(productConfig.productId) !== String(config.productId)) {
      productCustomizerConfigStatus = 'product_id_mismatch';
      return null;
    }

    productCustomizerConfigStatus = 'configured_product';
    return productConfig;
  }

  function getUnsupportedTemplateMessage() {
    return productCustomizerConfigStatus === 'configured_product'
      ? t('missingTemplateForVariant')
      : t('missingTemplateConfiguration');
  }

  function getProductContainer() {
    var current = customizerRoot;

    while (current && current !== document.body) {
      if (current.querySelector && current.querySelector('[data-variant-json]')) {
        return current;
      }

      current = current.parentElement;
    }

    return document;
  }

  function variantMatchesOptionValues(variant, optionValues) {
    if (!variant || !Array.isArray(variant.options) || !Array.isArray(optionValues)) {
      return false;
    }

    if (variant.options.length !== optionValues.length) {
      return false;
    }

    return variant.options.every(function (option, index) {
      return String(option) === String(optionValues[index]);
    });
  }

  function getVariantFromOptionValues(optionValues) {
    if (!Array.isArray(config.variants)) {
      return null;
    }

    return config.variants.find(function (variant) {
      return variantMatchesOptionValues(variant, optionValues);
    }) || null;
  }

  function getVariantFromSelectedInputs() {
    var container = getProductContainer();
    var selectedValues = [];
    var optionInputs = container.querySelectorAll('[data-variant-input]');

    if (!optionInputs.length) {
      return null;
    }

    optionInputs.forEach(function (input) {
      var indexMatch = String(input.dataset.index || '').match(/^option(\d+)$/);
      var optionIndex = indexMatch ? parseInt(indexMatch[1], 10) - 1 : -1;

      if (optionIndex < 0) {
        return;
      }

      if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) {
        return;
      }

      selectedValues[optionIndex] = input.value;
    });

    if (!selectedValues.length || selectedValues.some(function (value) { return value == null; })) {
      return null;
    }

    return getVariantFromOptionValues(selectedValues);
  }

  function getVariantFromEventDetail(detail) {
    var selectedValues = [];

    if (!detail || !Array.isArray(detail.currentlySelectedValues)) {
      return detail && detail.variant ? detail.variant : null;
    }

    detail.currentlySelectedValues.forEach(function (selected) {
      var indexMatch = String(selected.index || '').match(/^option(\d+)$/);
      var optionIndex = indexMatch ? parseInt(indexMatch[1], 10) - 1 : -1;

      if (optionIndex >= 0) {
        selectedValues[optionIndex] = selected.value;
      }
    });

    return getVariantFromOptionValues(selectedValues) || detail.variant || null;
  }

  function getCurrentVariant() {
    var variantId = null;
    var form = customizerRoot ? findProductForm(customizerRoot) : null;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var selectedInputVariant = getVariantFromSelectedInputs();

    if (selectedInputVariant) {
      return selectedInputVariant;
    }

    if (idInput && idInput.value) {
      variantId = String(idInput.value);
    } else if (config.selectedVariantId != null) {
      variantId = String(config.selectedVariantId);
    } else if (config.variantId != null) {
      variantId = String(config.variantId);
    }

    if (!Array.isArray(config.variants)) {
      return null;
    }

    return config.variants.find(function (variant) {
      return String(variant.id) === variantId;
    }) || null;
  }

  function resolveTemplateForVariant(variant) {
    var registry = config && config.templateRegistry;
    var productConfig = getProductCustomizerConfig(variant);
    var templateKey = null;

    productCustomizerConfig = productConfig;

    if (!registry || !registry.templates || !productConfig) {
      return null;
    }

    if (variant && productConfig.variantIdTemplateMap && productConfig.variantIdTemplateMap[String(variant.id)]) {
      templateKey = productConfig.variantIdTemplateMap[String(variant.id)];
    }

    if (!templateKey || !registry.templates[templateKey] || registry.templates[templateKey].enabled === false) {
      return null;
    }

    return {
      key: templateKey,
      template: registry.templates[templateKey]
    };
  }

  function normalizeTemplate(templateEntry) {
    var template = templateEntry && templateEntry.template;
    var scenes = {};
    var sceneList = Array.isArray(template && template.scenes) ? template.scenes : [];
    var defaultScene = null;

    sceneList.forEach(function (scene) {
      if (!scene || !scene.id) {
        return;
      }

      if (!defaultScene || scene.default === true) {
        defaultScene = scene;
      }

      scenes[scene.id] = {
        id: scene.id,
        label: scene.label || scene.id,
        mockupUrl: scene.mockupUrl,
        printArea: scene.printArea || template.printArea,
        layers: Array.isArray(scene.layers) ? scene.layers : []
      };
    });

    return {
      key: templateEntry.key,
      templateId: template.templateId,
      templateVersion: template.templateVersion,
      productType: template.productType,
      canvas: template.canvas,
      printArea: template.printArea,
      customerImageFitOverscan: template.customerImageFitOverscan || null,
      features: template.features || {},
      cardTemplates: template.cardTemplates || [],
      cardTemplateGeometry: template.cardTemplateGeometry || null,
      defaultSceneId: defaultScene ? defaultScene.id : Object.keys(scenes)[0],
      contextSceneId: template.contextSceneId || (scenes.context ? 'context' : null),
      scenes: scenes,
      output: template.output || {}
    };
  }

  function setUnsupportedTemplateState(message) {
    clearCardTemplate();
    currentTemplate = null;
    currentTemplateKey = null;
    config.templateId = null;
    config.templateVersion = null;
    resetBackendStateForTemplateChange();
    removeCustomizerProperties(getCurrentProductForm());
    if (canvas) {
      removeSceneObjects();
      canvas.requestRenderAll();
    }
    setControlsDisabled(true);
    setCustomizerStatus(STATUS.IDLE, message || getUnsupportedTemplateMessage(), 'error');
  }

  function resetBackendStateForTemplateChange() {
    backendState.currentDesignId = null;
    backendState.designId = null;
    backendState.finalizedDesignId = null;
    backendState.finalizedVariantId = null;
    backendState.editToken = null;
    backendState.originalAssetId = null;
    backendState.uploadedAssetId = null;
    backendState.thumbnailUrl = null;
    backendState.originalUrl = null;
    backendState.productionUrl = null;
    backendState.upscaledOriginalUrl = null;
    backendState.upscaledProductionUrl = null;
    backendState.hasUploadedArtwork = false;
    backendState.isUploading = false;
    backendState.isFinalizing = false;
    backendState.isAddToCartInProgress = false;
    backendState.isSceneLoading = false;
  }

  function hasReusableUploadedArtwork() {
    return !!(state.customerImage && backendState.hasUploadedArtwork && backendState.uploadedAssetId);
  }

  function invalidateGeneratedOutputsForTemplateChange() {
    backendState.finalizedDesignId = null;
    backendState.finalizedVariantId = null;
    backendState.thumbnailUrl = null;
    backendState.productionUrl = null;
    backendState.upscaledOriginalUrl = null;
    backendState.upscaledProductionUrl = null;
    syncDeferredCustomizerProperties(getCurrentProductForm());
  }

  function updateBackendPayloadTemplateFields() {
    if (!currentTemplate) {
      return;
    }

    config.templateId = currentTemplate.templateId;
    config.templateVersion = currentTemplate.templateVersion;
    config.canvas = currentTemplate.canvas;
    config.scenes = currentTemplate.scenes;
    config.variantId = currentVariant && currentVariant.id != null
      ? currentVariant.id
      : config.selectedVariantId;
  }

  function api(path, options) {
    var requestOptions = options || {};
    var headers = Object.assign({
      'Accept': 'application/json'
    }, requestOptions.headers || {});

    if (requestOptions.body && typeof requestOptions.body !== 'string') {
      headers['Content-Type'] = 'application/json';
      requestOptions.body = JSON.stringify(requestOptions.body);
    }

    return window.fetch(joinApiPath(config.apiBasePath, path), Object.assign({}, requestOptions, {
      headers: headers
    })).then(function (response) {
      return readResponsePayload(response).then(function (payload) {
        if (!response.ok) {
          throw buildRequestError('[TiltCustomizer] API request failed', response, payload);
        }

        return payload;
      });
    });
  }

  function ensureDesign() {
    if (backendState.designId && backendState.editToken) {
      return Promise.resolve(backendState);
    }

    if (config.backendEnabled !== true) {
      return Promise.resolve(null);
    }

    if (!currentTemplate) {
      return Promise.reject(new Error('[TiltCustomizer] Missing template configuration for current variant.'));
    }

    return api('/designs', {
      method: 'POST',
      body: {
        templateId: config.templateId,
        templateVersion: config.templateVersion,
        shopifyProductId: config.productId == null ? null : String(config.productId),
        shopifyVariantId: config.variantId == null ? null : String(config.variantId),
        sessionId: sessionId || getOrCreateSessionId()
      }
    }).then(function (response) {
      if (!response || !response.designId || !response.editToken) {
        throw new Error('[TiltCustomizer] API response did not include designId/editToken.');
      }

      backendState.currentDesignId = response.designId;
      backendState.designId = response.designId;
      backendState.editToken = response.editToken;
      return backendState;
    });
  }

  function saveDesignState() {
    if (config.backendEnabled !== true) {
      console.warn('[TiltCustomizer] backend disabled.');
      return Promise.resolve(null);
    }

    return ensureDesign().then(function () {
      if (!backendState.designId || !backendState.editToken) {
        throw new Error('[TiltCustomizer] Missing design state.');
      }

      return api('/designs/' + encodeURIComponent(backendState.designId) + '/state', {
        method: 'PATCH',
        body: {
          editToken: backendState.editToken,
          state: exportState()
        }
      });
    }).then(function (response) {
      debugLog('[TiltCustomizer] Design state saved.');
      return response;
    });
  }

  function requestUploadUrl(file) {
    if (!backendState.designId || !backendState.editToken) {
      throw new Error('[TiltCustomizer] Missing design before upload URL request.');
    }

    return api('/designs/' + encodeURIComponent(backendState.designId) + '/upload-url', {
      method: 'POST',
      body: {
        editToken: backendState.editToken,
        fileName: file.name,
        contentType: file.type,
        sizeBytes: file.size
      }
    });
  }

  function uploadToStorage(file, upload) {
    if (!upload || !upload.method || !upload.url) {
      throw new Error('[TiltCustomizer] Invalid upload instructions.');
    }

    if (upload.method === 'PUT') {
      return window.fetch(upload.url, {
        method: 'PUT',
        headers: upload.headers || {},
        body: file
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('[TiltCustomizer] Storage upload failed: HTTP ' + response.status);
          error.httpStatus = response.status;
          throw error;
        }
      });
    }

    if (upload.method === 'POST') {
      var formData = new window.FormData();
      Object.keys(upload.fields || {}).forEach(function (key) {
        formData.append(key, upload.fields[key]);
      });
      formData.append('file', file);

      return window.fetch(upload.url, {
        method: 'POST',
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('[TiltCustomizer] Storage upload failed: HTTP ' + response.status);
          error.httpStatus = response.status;
          throw error;
        }
      });
    }

    throw new Error('[TiltCustomizer] Unsupported upload method: ' + upload.method);
  }

  function completeUpload(assetId) {
    if (!backendState.designId || !backendState.editToken) {
      throw new Error('[TiltCustomizer] Missing design before upload completion.');
    }

    return api('/designs/' + encodeURIComponent(backendState.designId) + '/assets/' + encodeURIComponent(assetId) + '/complete', {
      method: 'POST',
      body: {
        editToken: backendState.editToken
      }
    });
  }

  function setUploadStatus(message, type) {
    if (!uploadStatusElement) {
      return;
    }

    if (!message) {
      uploadStatusElement.hidden = true;
      uploadStatusElement.textContent = '';
      uploadStatusElement.classList.remove('is-error', 'is-success', 'is-loading');
      uploadStatusElement.setAttribute('role', 'status');
      return;
    }

    uploadStatusElement.textContent = message;
    uploadStatusElement.classList.toggle('is-error', type === 'error');
    uploadStatusElement.classList.toggle('is-success', type === 'success');
    uploadStatusElement.classList.toggle('is-loading', type === 'loading');
    uploadStatusElement.setAttribute('role', type === 'error' ? 'alert' : 'status');
    uploadStatusElement.hidden = false;
  }

  function waitForNextFrame() {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        resolve();
      });
    });
  }

  function createThumbnailBlob() {
    if (backendState.isCardTemplateLoading && cardTemplateLoadPromise) {
      return cardTemplateLoadPromise.then(function (ready) {
        if (!ready) { throw new Error('[TiltCustomizer] Card template preview is not ready.'); }
        return createThumbnailBlob();
      });
    }
    if (!canvas || !canvas.lowerCanvasEl) {
      return Promise.reject(new Error('[TiltCustomizer] Canvas is not ready.'));
    }

    if (typeof canvas.lowerCanvasEl.toBlob !== 'function') {
      return Promise.reject(new Error('[TiltCustomizer] Canvas thumbnail export is not supported by this browser.'));
    }

    var activeObject = canvas.getActiveObject();
    var previousBackgroundColor = canvas.backgroundColor;

    if (activeObject) {
      canvas.discardActiveObject();
      debugLog('[TiltCustomizer] thumbnail export temporarily cleared active selection');
    }

    canvas.backgroundColor = THUMBNAIL_BACKGROUND_COLOR;
    canvas.requestRenderAll();
    return waitForNextFrame()
      .then(function () {
        return new Promise(function (resolve, reject) {
          try {
            canvas.lowerCanvasEl.toBlob(function (blob) {
              if (!blob) {
                reject(new Error('[TiltCustomizer] Could not generate thumbnail blob.'));
                return;
              }

              resolve(blob);
            }, 'image/webp', 0.85);
          } catch (error) {
            reject(new Error('[TiltCustomizer] Could not generate thumbnail. Check image CORS settings.'));
          }
        });
      })
      .finally(function () {
        canvas.backgroundColor = previousBackgroundColor || '';

        if (activeObject) {
          canvas.setActiveObject(activeObject);
        }

        canvas.requestRenderAll();
      });
  }

  function getThumbnailBlobMetadata(blob) {
    var contentType = blob && typeof blob.type === 'string' ? blob.type.toLowerCase() : '';
    var extensionByContentType = {
      'image/webp': 'webp',
      'image/png': 'png',
      'image/jpeg': 'jpg'
    };

    var extension = extensionByContentType[contentType];
    if (!extension) {
      throw new Error('[TiltCustomizer] Unsupported thumbnail blob type: ' + (contentType || 'empty'));
    }

    return {
      contentType: contentType,
      fileName: 'thumbnail.' + extension,
      sizeBytes: blob.size || 0
    };
  }

  function uploadThumbnail() {
    if (config.backendEnabled !== true) {
      return Promise.resolve(null);
    }

    if (!backendState.designId || !backendState.editToken) {
      throw new Error('[TiltCustomizer] Missing design before thumbnail upload.');
    }

    var thumbnailStartedAt = Date.now();
    var thumbnailBlobTelemetry = null;
    setCustomizerStatus(STATUS.THUMBNAIL_GENERATING, t('preparingPreview'), 'loading');
    trackTelemetryEvent('frontend_preview_started');

    return createThumbnailBlob()
      .then(function (blob) {
        var thumbnailBlob = getThumbnailBlobMetadata(blob);
        thumbnailBlobTelemetry = {
          thumbnailBlobType: thumbnailBlob.contentType,
          thumbnailBlobSize: thumbnailBlob.sizeBytes
        };

        var formData = new window.FormData();
        formData.append('editToken', backendState.editToken);
        formData.append('file', blob, thumbnailBlob.fileName);

        return window.fetch(joinApiPath(config.apiBasePath, '/designs/' + encodeURIComponent(backendState.designId) + '/thumbnail'), {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });
      })
      .then(function (response) {
        return readResponsePayload(response).then(function (payload) {
          if (!response.ok) {
            throw buildRequestError('[TiltCustomizer] Thumbnail upload failed', response, payload);
          }

          return payload;
        });
      })
      .then(function (response) {
        backendState.thumbnailUrl = response && response.thumbUrl ? response.thumbUrl : null;
        trackTelemetryEvent('frontend_preview_completed', Object.assign({
          durationMs: Date.now() - thumbnailStartedAt
        }, thumbnailBlobTelemetry || {}));
        return backendState.thumbnailUrl;
      })
      .catch(function (error) {
        trackTelemetryEvent('frontend_preview_failed', Object.assign({
          durationMs: Date.now() - thumbnailStartedAt
        }, thumbnailBlobTelemetry || {}, getErrorTelemetryData(error)));
        setCustomizerStatus(STATUS.THUMBNAIL_GENERATING, t('previewFailed'), 'error');
        throw error;
      });
  }
  function finalizeDesignForCart() {
    if (config.backendEnabled !== true) {
      console.warn('[TiltCustomizer] backend disabled.');
      return Promise.resolve(null);
    }

    var finalizedState = null;
    backendState.isFinalizing = true;
    setCustomizerStatus(STATUS.FINALIZING, t('preparingCustomization'), 'loading');

    return ensureCurrentVariantTemplateReady()
      .then(function (templateReady) {
        if (!templateReady) {
          throw new Error('[TiltCustomizer] Missing template configuration for current variant.');
        }

        return ensureDesign();
      })
      .then(function () {
        if (!backendState.designId || !backendState.editToken) {
          throw new Error('[TiltCustomizer] Missing design before cart finalize.');
        }

        return uploadThumbnail();
      })
      .then(function (thumbUrl) {
        setCustomizerStatus(STATUS.FINALIZING, t('preparingCustomization'), 'loading');
        finalizedState = exportState();

        return api('/designs/' + encodeURIComponent(backendState.designId) + '/finalize-cart', {
          method: 'POST',
          body: {
            editToken: backendState.editToken,
            state: finalizedState,
            thumbnailUrl: thumbUrl
          }
        });
      })
      .then(function (response) {
        if (!response || !response.designId) {
          throw new Error('[TiltCustomizer] Finalize response did not include designId.');
        }

        if (!finalizedState || String(finalizedState.variantId) !== getCurrentVariantIdForCart()) {
          invalidateGeneratedOutputsForTemplateChange();
          throw new Error('[TiltCustomizer] Variant changed during cart finalization.');
        }

        backendState.finalizedDesignId = response.designId;
        backendState.finalizedVariantId = finalizedState && finalizedState.variantId != null
          ? String(finalizedState.variantId) : null;
        backendState.thumbnailUrl = response.thumbUrl || null;
        backendState.originalUrl = response.originalUrl || null;
        backendState.productionUrl = response.productionUrl || null;
        backendState.upscaledOriginalUrl = response.upscaledOriginalUrl || null;
        backendState.upscaledProductionUrl = response.upscaledProductionUrl || null;

        if (!backendState.thumbnailUrl) {
          console.warn('[TiltCustomizer] Finalized design has no thumbUrl.');
        }

        backendState.isFinalizing = false;
        setCustomizerStatus(STATUS.READY_FOR_CART, null);

        return {
          designId: response.designId,
          thumbUrl: backendState.thumbnailUrl,
          originalUrl: backendState.originalUrl,
          productionUrl: backendState.productionUrl,
          upscaledOriginalUrl: backendState.upscaledOriginalUrl,
          upscaledProductionUrl: backendState.upscaledProductionUrl
        };
      })
      .catch(function (error) {
        backendState.isFinalizing = false;
        throw error;
      });
  }

  function hasStartedPersonalization() {
    return !!(state.customerImage || backendState.designId || backendState.uploadedAssetId);
  }

  function hasUploadedArtworkForCart() {
    return !!(state.customerImage && backendState.hasUploadedArtwork && backendState.uploadedAssetId);
  }

  function addOrUpdateHiddenInput(form, name, value) {
    var input = form.querySelector('input[type="hidden"][name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value == null ? '' : String(value);
  }

  function buildAbsolutePublicCustomizerUrl(path) {
    var url = joinApiPath(config.apiBasePath, path);

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return window.location.origin.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
  }

  function buildDesignPublicAssetUrl(designId, assetKind) {
    if (!designId || !assetKind) {
      return '';
    }

    return buildAbsolutePublicCustomizerUrl('/public/designs/' + encodeURIComponent(designId) + '/' + encodeURIComponent(assetKind));
  }

  function getCurrentLineItemStateJson() {
    if (!currentTemplate || !state.customerImage) {
      return '';
    }

    return JSON.stringify(exportState());
  }

  function resolveLineItemUrls(designId, thumbUrl, originalUrl, productionUrl) {
    return {
      thumbUrl: thumbUrl || backendState.thumbnailUrl || '',
      originalUrl: originalUrl || backendState.originalUrl || buildDesignPublicAssetUrl(designId, 'original'),
      productionUrl: productionUrl || backendState.productionUrl || buildDesignPublicAssetUrl(designId, 'production'),
      upscaledOriginalUrl: backendState.upscaledOriginalUrl || '',
      upscaledProductionUrl: backendState.upscaledProductionUrl || ''
    };
  }

  function addOrUpdateCustomizerProperties(form, designId, thumbUrl, originalUrl, productionUrl, stateJson) {
    var urls = resolveLineItemUrls(designId, thumbUrl, originalUrl, productionUrl);

    addOrUpdateHiddenInput(form, 'properties[_design_id]', designId);
    addOrUpdateHiddenInput(form, 'properties[_thumb_url]', urls.thumbUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_customily-preview]', urls.thumbUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_customily-thumb]', urls.thumbUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_customily-original]', urls.originalUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_customily-production-url]', urls.productionUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_tilt-original-upscaled-url]', urls.upscaledOriginalUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_tilt-production-upscaled-url]', urls.upscaledProductionUrl || '');
    addOrUpdateHiddenInput(form, 'properties[_tilt_state]', stateJson || getCurrentLineItemStateJson());
    addOrUpdateHiddenInput(form, 'properties[Personalizacja]', 'Grafika przesłana');
  }

  function syncDeferredCustomizerProperties(form) {
    var designId = backendState.currentDesignId || backendState.designId;

    if (!form || !currentTemplate || !designId || !hasUploadedArtworkForCart()) {
      removeCustomizerProperties(form);
      return false;
    }

    syncProductFormVariantId(form);
    addOrUpdateCustomizerProperties(form, designId, null, null, null, getCurrentLineItemStateJson());
    return true;
  }

  function removeCustomizerProperties(form) {
    if (!form) {
      return;
    }

    [
      'properties[_design_id]',
      'properties[_thumb_url]',
      'properties[_customily-preview]',
      'properties[_customily-thumb]',
      'properties[_customily-original]',
      'properties[_customily-production-url]',
      'properties[_tilt-original-upscaled-url]',
      'properties[_tilt-production-upscaled-url]',
      'properties[_tilt_state]',
      'properties[Personalizacja]'
    ].forEach(function (name) {
      var input = form.querySelector('input[type="hidden"][name="' + name + '"]');

      if (input && input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
  }

  function getCurrentProductForm() {
    return customizerRoot ? findProductForm(customizerRoot) : null;
  }

  function getAddToCartButtonTextNode(button) {
    if (!button) {
      return null;
    }

    return button.querySelector('[data-add-to-cart-text]') || button;
  }

  function setAddToCartBusy(button, busy) {
    var textNode = getAddToCartButtonTextNode(button);

    if (!button) {
      return;
    }

    if (busy) {
      addToCartButtonWasDisabled = button.disabled;

      if (textNode && addToCartButtonOriginalText == null) {
        addToCartButtonOriginalText = textNode.textContent;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      if (textNode) {
        textNode.textContent = t('processing');
      }

      return;
    }

    button.disabled = addToCartButtonWasDisabled;
    button.removeAttribute('aria-busy');

    if (textNode && addToCartButtonOriginalText != null) {
      textNode.textContent = addToCartButtonOriginalText;
    }

    addToCartButtonOriginalText = null;
  }

  function isCustomizerBusy() {
    return backendState.isUploading || backendState.isFinalizing || backendState.isAddToCartInProgress || backendState.isSceneLoading || backendState.isCardTemplateLoading;
  }

  function setControlsDisabled(disabled) {
    if (!customizerRoot) {
      return;
    }

    customizerRoot.classList.toggle('is-busy', disabled);
    customizerRoot.setAttribute('aria-busy', disabled ? 'true' : 'false');

    customizerRoot
      .querySelectorAll('#TiltImageUpload, [data-scene], [data-tilt-scene-toggle], [data-tilt-card-template]')
      .forEach(function (control) {
        control.disabled = disabled;
      });

    if (addToCartButton && !backendState.isAddToCartInProgress) {
      if (disabled) {
        controlsAddToCartWasDisabled = addToCartButton.disabled;
        addToCartButton.disabled = true;
        addToCartButton.setAttribute('aria-busy', 'true');
      } else {
        addToCartButton.disabled = controlsAddToCartWasDisabled;
        addToCartButton.removeAttribute('aria-busy');
      }
    }
  }

  function focusCustomizerStatus() {
    var focusTarget = uploadStatusElement || customizerRoot;

    if (!focusTarget) {
      return;
    }

    if (typeof focusTarget.scrollIntoView === 'function') {
      focusTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    if (typeof focusTarget.focus === 'function') {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }
  }

  function findProductForm(root) {
    var current = root;

    while (current && current !== document.body) {
      var scopedForm = Array.prototype.find.call(
        current.querySelectorAll('form[action*="/cart/add"]'),
        function (form) {
          return !!form.querySelector('[data-add-to-cart]');
        }
      );

      if (scopedForm) {
        debugLog('[TiltCustomizer] product form found.');
        return scopedForm;
      }

      current = current.parentElement;
    }

    console.warn('[TiltCustomizer] product add-to-cart form not found');
    return null;
  }

  function findAddToCartButton(form) {
    var button = form ? form.querySelector('[data-add-to-cart]') : null;

    if (!button) {
      console.warn('[TiltCustomizer] product add-to-cart button not found');
      return null;
    }

    debugLog('[TiltCustomizer] add-to-cart button found.');
    return button;
  }

  function isCartAddRequest(input) {
    var url = typeof input === 'string'
      ? input
      : input && input.url;

    return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
  }

  function hasCustomizerProperties(form) {
    return !!(form &&
      form.querySelector('input[name="properties[_design_id]"]') &&
      form.querySelector('input[name="properties[_thumb_url]"]') &&
      form.querySelector('input[name="properties[Personalizacja]"]'));
  }

  function buildCartAddResponse(status, description) {
    return new window.Response(JSON.stringify({
      status: status,
      description: description
    }), {
      status: status,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  function getCurrentVariantIdForCart() {
    var selectedVariant = getCurrentVariant();

    if (selectedVariant && selectedVariant.id != null) {
      currentVariant = selectedVariant;
      config.selectedVariantId = selectedVariant.id;
      config.variantId = selectedVariant.id;
    }

    return currentVariant && currentVariant.id != null
      ? String(currentVariant.id)
      : null;
  }

  function syncProductFormVariantId(form) {
    var variantId = getCurrentVariantIdForCart();
    var variantInput = form ? form.querySelector('[name="id"]') : null;

    if (!variantId || !variantInput) {
      return variantId;
    }

    if (String(variantInput.value) !== variantId) {
      variantInput.value = variantId;
      debugLog('[TiltCustomizer] product form variant id synced before add-to-cart.', {
        variantId: variantId
      });
    }

    return variantId;
  }

  function applyCartVariantIdToBody(payload, variantId) {
    if (!variantId || !payload) {
      return payload;
    }

    if (Array.isArray(payload.items) && payload.items.length > 0) {
      payload.items[0].id = variantId;
      return payload;
    }

    payload.id = variantId;
    return payload;
  }

  function buildCustomizerProperties(designId, thumbUrl, originalUrl, productionUrl, stateJson) {
    var urls = resolveLineItemUrls(designId, thumbUrl, originalUrl, productionUrl);

    return {
      _design_id: designId,
      _thumb_url: urls.thumbUrl || '',
      '_customily-preview': urls.thumbUrl || '',
      '_customily-thumb': urls.thumbUrl || '',
      '_customily-original': urls.originalUrl || '',
      '_customily-production-url': urls.productionUrl || '',
      '_tilt-original-upscaled-url': urls.upscaledOriginalUrl || '',
      '_tilt-production-upscaled-url': urls.upscaledProductionUrl || '',
      _tilt_state: stateJson || getCurrentLineItemStateJson(),
      Personalizacja: 'Grafika przesłana'
    };
  }

  function parseCartAddBody(body) {
    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  }

  function getPrimaryCartAddItem(payload) {
    if (!payload) {
      return null;
    }

    if (Array.isArray(payload.items) && payload.items.length > 0) {
      return payload.items[0];
    }

    return payload;
  }

  function isCurrentProductVariantId(variantId) {
    if (variantId == null || !Array.isArray(config.variants)) {
      return false;
    }

    return config.variants.some(function (variant) {
      return variant && variant.id != null && String(variant.id) === String(variantId);
    });
  }

  function isCurrentProductCartAddPayload(payload) {
    var item = getPrimaryCartAddItem(payload);
    var itemProductId = item && (item['product-id'] || item.product_id || item.productId);
    var itemVariantId = item && (item.id || item.variant_id || item.variantId);

    if (!item) {
      return false;
    }

    if (itemProductId != null && config.productId != null) {
      return String(itemProductId) === String(config.productId);
    }

    return isCurrentProductVariantId(itemVariantId);
  }
  function applyCustomizerPropertiesToCartAddBody(body, designId, thumbUrl, originalUrl, productionUrl) {
    var payload = parseCartAddBody(body);

    if (!payload) {
      throw new Error('[TiltCustomizer] Invalid cart/add JSON body.');
    }
    var variantId = getCurrentVariantIdForCart();
    var properties = buildCustomizerProperties(designId, thumbUrl, originalUrl, productionUrl);

    applyCartVariantIdToBody(payload, variantId);

    if (Array.isArray(payload.items) && payload.items.length > 0) {
      payload.items[0].properties = Object.assign({}, payload.items[0].properties || {}, properties);
      return JSON.stringify(payload);
    }

    payload.properties = Object.assign({}, payload.properties || {}, properties);
    return JSON.stringify(payload);
  }

  function hasCurrentGeneratedOutputsForCart() {
    var variantId = getCurrentVariantIdForCart();
    return !!(backendState.finalizedDesignId && backendState.thumbnailUrl &&
      variantId && backendState.finalizedVariantId === variantId);
  }

  function applyCurrentCustomizerPropertiesToCartAddBody(body) {
    return applyCustomizerPropertiesToCartAddBody(
      body,
      backendState.finalizedDesignId,
      backendState.thumbnailUrl,
      backendState.originalUrl,
      backendState.productionUrl
    );
  }
  function withCartAddBody(init, body) {
    var next = Object.assign({}, init || {});
    var headers = new window.Headers(next.headers || {});

    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }

    next.headers = headers;
    next.body = body;
    return next;
  }

  function installCartAddFetchInterceptor(form, button) {
    if (window.__tiltCustomizerCartAddFetchInterceptor === true) {
      return;
    }

    var originalFetch = window.fetch;
    window.__tiltCustomizerCartAddFetchInterceptor = true;

    window.fetch = function (input, init) {
      var fetchThis = this;
      var body = init && init.body;

      if (!isCartAddRequest(input) || config.backendEnabled !== true) {
        return originalFetch.apply(fetchThis, arguments);
      }

      if (typeof body !== 'string' || body.charAt(0) !== '{') {
        syncProductFormVariantId(form);
        return originalFetch.apply(fetchThis, arguments);
      }

      if (!isCurrentProductCartAddPayload(parseCartAddBody(body))) {
        debugLog('[TiltCustomizer] cart/add ignored because payload is not current customizer product.');
        return originalFetch.apply(fetchThis, arguments);
      }

      if (hasCustomizerProperties(form) && hasCurrentGeneratedOutputsForCart()) {
        syncProductFormVariantId(form);
        return originalFetch.call(
          fetchThis,
          input,
          withCartAddBody(init, applyCurrentCustomizerPropertiesToCartAddBody(body))
        );
      }

      if (!hasUploadedArtworkForCart()) {
        trackTelemetryEvent('frontend_add_to_cart_blocked_no_artwork', { source: 'fetch_interceptor', reason: 'missing_artwork' });
        setCustomizerStatus(STATUS.IDLE, t('uploadArtworkBeforeCart'), 'error');
        focusCustomizerStatus();
        return Promise.resolve(buildCartAddResponse(200, t('uploadArtworkBeforeCart')));
      }

      if (isCustomizerBusy()) {
        trackTelemetryEvent('frontend_add_to_cart_blocked_busy', { source: 'fetch_interceptor', reason: 'customizer_busy' });
        setCustomizerStatus(backendState.status, t('processing'), 'loading');
        return Promise.resolve(buildCartAddResponse(429, t('customizerProcessing')));
      }

      backendState.isAddToCartInProgress = true;
      setAddToCartBusy(button, true);
      setControlsDisabled(true);
      setCustomizerStatus(STATUS.ADD_TO_CART_IN_PROGRESS, t('processing'), 'loading');
      trackTelemetryEvent('frontend_add_to_cart_clicked', { source: 'fetch_interceptor' });
      debugLog('[TiltCustomizer] cart/add fetch intercepted.');

      return finalizeDesignForCart()
        .then(function (result) {
          if (!result || !result.designId) {
            throw new Error('[TiltCustomizer] Finalized design is missing.');
          }

          syncProductFormVariantId(form);
          addOrUpdateCustomizerProperties(form, result.designId, result.thumbUrl, result.originalUrl, result.productionUrl);
          var patchedBody = applyCustomizerPropertiesToCartAddBody(body, result.designId, result.thumbUrl, result.originalUrl, result.productionUrl);
          trackTelemetryEvent('frontend_add_to_cart_completed', { source: 'fetch_interceptor' });
          debugLog('[TiltCustomizer] cart/add body patched with customizer properties.');
          return originalFetch.call(fetchThis, input, withCartAddBody(init, patchedBody));
        })
        .catch(function (error) {
          console.error('[TiltCustomizer] cart/add finalize error.', error);
          trackTelemetryEvent('frontend_add_to_cart_failed', Object.assign({ source: 'fetch_interceptor' }, getErrorTelemetryData(error)));
          setCustomizerStatus(STATUS.ADD_TO_CART_FAILED, t('addToCartFailed'), 'error');
          focusCustomizerStatus();
          return buildCartAddResponse(422, t('addToCartFailed'));
        })
        .finally(function () {
          setControlsDisabled(false);
          backendState.isAddToCartInProgress = false;
          setAddToCartBusy(button, false);
        });
    };
  }
  function findDynamicCheckoutButton(target) {
    var current = target;

    while (current && current !== document) {
      if (current.matches && (
        current.matches('.shopify-payment-button__button') ||
        current.matches('.shopify-payment-button button') ||
        current.matches('.shopify-payment-button [role="button"]') ||
        current.matches('.shopify-payment-button')
      )) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function isDynamicCheckoutForCurrentProduct(dynamicCheckoutButton, form) {
    var productSection = customizerRoot
      ? customizerRoot.closest('.product-section, .shopify-section, .product-single__grid')
      : null;

    if (!dynamicCheckoutButton) {
      return false;
    }

    if (form && form.contains(dynamicCheckoutButton)) {
      return true;
    }

    return !productSection || productSection.contains(dynamicCheckoutButton);
  }

  function installDynamicCheckoutIntegration(form) {
    if (!form || form.dataset.tiltCustomizerDynamicCheckoutBound === 'true') {
      return;
    }

    form.dataset.tiltCustomizerDynamicCheckoutBound = 'true';

    document.addEventListener('click', function (event) {
      var dynamicCheckoutButton = findDynamicCheckoutButton(event.target);

      if (!dynamicCheckoutButton || config.backendEnabled !== true) {
        return;
      }

      if (!isDynamicCheckoutForCurrentProduct(dynamicCheckoutButton, form)) {
        return;
      }

      debugLog('[TiltCustomizer] dynamic checkout validated.');
      syncProductFormVariantId(form);
      syncDeferredCustomizerProperties(form);
      trackTelemetryEvent('frontend_dynamic_checkout_clicked', { isDynamicCheckout: true });

      if (!currentTemplate) {
        event.preventDefault();
        event.stopImmediatePropagation();
        trackTelemetryEvent('frontend_dynamic_checkout_blocked_missing_template', { isDynamicCheckout: true, reason: 'missing_template' });
        setCustomizerStatus(STATUS.IDLE, getUnsupportedTemplateMessage(), 'error');
        focusCustomizerStatus();
        return;
      }

      if (!hasUploadedArtworkForCart()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        trackTelemetryEvent('frontend_dynamic_checkout_blocked_no_artwork', { isDynamicCheckout: true, reason: 'missing_artwork' });
        setCustomizerStatus(STATUS.IDLE, t('uploadArtworkBeforeCart'), 'error');
        focusCustomizerStatus();
        return;
      }

      if (backendState.isUploading || backendState.isSceneLoading || backendState.isCardTemplateLoading) {
        event.preventDefault();
        event.stopImmediatePropagation();
        trackTelemetryEvent('frontend_dynamic_checkout_blocked_busy', { isDynamicCheckout: true, reason: 'customizer_busy' });
        setCustomizerStatus(backendState.status, t('processing'), 'loading');
        return;
      }
    }, true);
  }
  function initAddToCartIntegration(root) {
    var form = findProductForm(root);

    if (!form) {
      return;
    }

    var button = findAddToCartButton(form);

    if (!button || button.dataset.tiltCustomizerAddToCartBound === 'true') {
      return;
    }

    addToCartButton = button;
    button.dataset.tiltCustomizerAddToCartBound = 'true';
    installCartAddFetchInterceptor(form, button);
    installDynamicCheckoutIntegration(form);

    function shouldAllowNativeAddToCart() {
      if (backendState.allowNativeAddToCartOnce) {
        backendState.allowNativeAddToCartOnce = false;
        return true;
      }

      return false;
    }

    function handleAddToCartEvent(event, replayNativeAddToCart) {
      if (config.backendEnabled !== true) {
        return;
      }

      if (shouldAllowNativeAddToCart()) {
        debugLog('[TiltCustomizer] native add-to-cart allowed after finalize.');
        return;
      }

      debugLog('[TiltCustomizer] add-to-cart intercepted.');
      syncProductFormVariantId(form);
      trackTelemetryEvent('frontend_add_to_cart_clicked', { source: 'native_interceptor' });

      if (!currentTemplate) {
        event.preventDefault();
        event.stopImmediatePropagation();
        trackTelemetryEvent('frontend_add_to_cart_blocked_missing_template', { source: 'native_interceptor', reason: 'missing_template' });
        setCustomizerStatus(STATUS.IDLE, getUnsupportedTemplateMessage(), 'error');
        focusCustomizerStatus();
        return;
      }

      if (!hasUploadedArtworkForCart()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        trackTelemetryEvent('frontend_add_to_cart_blocked_no_artwork', { source: 'native_interceptor', reason: 'missing_artwork' });
        setCustomizerStatus(STATUS.IDLE, t('uploadArtworkBeforeCart'), 'error');
        focusCustomizerStatus();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isCustomizerBusy()) {
        trackTelemetryEvent('frontend_add_to_cart_blocked_busy', { source: 'native_interceptor', reason: 'customizer_busy' });
        setCustomizerStatus(backendState.status, t('processing'), 'loading');
        return;
      }

      backendState.isAddToCartInProgress = true;
      setAddToCartBusy(button, true);
      setControlsDisabled(true);
      setCustomizerStatus(STATUS.ADD_TO_CART_IN_PROGRESS, t('processing'), 'loading');
      debugLog('[TiltCustomizer] finalize started.');

      finalizeDesignForCart()
        .then(function (result) {
          if (!result || !result.designId) {
            throw new Error('[TiltCustomizer] Finalized design is missing.');
          }

          if (!result.thumbUrl) {
            console.warn('[TiltCustomizer] Adding customized product without thumbUrl.');
          }

          debugLog('[TiltCustomizer] thumbnail/finalize success.');
          trackTelemetryEvent('frontend_add_to_cart_completed', { source: 'native_interceptor' });
          syncProductFormVariantId(form);
          addOrUpdateCustomizerProperties(form, result.designId, result.thumbUrl, result.originalUrl, result.productionUrl);
          debugLog('[TiltCustomizer] properties attached.');

          setControlsDisabled(false);
          backendState.isAddToCartInProgress = false;
          setAddToCartBusy(button, false);
          setCustomizerStatus(STATUS.READY_FOR_CART, null);
          backendState.allowNativeAddToCartOnce = true;
          replayNativeAddToCart();
          debugLog('[TiltCustomizer] native add-to-cart replayed.');
        })
        .catch(function (error) {
          backendState.allowNativeAddToCartOnce = false;
          setControlsDisabled(false);
          backendState.isAddToCartInProgress = false;
          setAddToCartBusy(button, false);
          console.error('[TiltCustomizer] finalize error.', error);
          trackTelemetryEvent('frontend_add_to_cart_failed', Object.assign({ source: 'native_interceptor' }, getErrorTelemetryData(error)));
          setCustomizerStatus(STATUS.ADD_TO_CART_FAILED, t('addToCartFailed'), 'error');
          focusCustomizerStatus();
        });
    }

    button.addEventListener('click', function (event) {
      handleAddToCartEvent(event, function () {
        button.click();
      });
    }, true);

    form.addEventListener('submit', function (event) {
      handleAddToCartEvent(event, function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(button);
          return;
        }

        form.submit();
      });
    }, true);
  }
  function syncTemplateForVariant(variant, options) {
    var applyOptions = options || {};
    var nextVariant = variant || getCurrentVariant();
    var nextVariantId = nextVariant && nextVariant.id != null ? String(nextVariant.id) : null;
    var previousVariantId = currentVariant && currentVariant.id != null ? String(currentVariant.id) : null;
    var resolvedTemplate = null;

    currentVariant = nextVariant;
    config.selectedVariantId = currentVariant && currentVariant.id != null
      ? currentVariant.id
      : config.selectedVariantId;
    config.variantId = config.selectedVariantId;

    resolvedTemplate = resolveTemplateForVariant(currentVariant);

    if (!resolvedTemplate) {
      debugLog('[TiltCustomizer] no template for variant', {
        variantId: nextVariantId,
        options: currentVariant && currentVariant.options ? currentVariant.options : null
      });
      setUnsupportedTemplateState(getUnsupportedTemplateMessage());
      return false;
    }

    if (currentTemplateKey === resolvedTemplate.key && currentTemplate) {
      updateBackendPayloadTemplateFields();
      if (previousVariantId && previousVariantId !== nextVariantId) {
        invalidateGeneratedOutputsForTemplateChange();
      }
      return true;
    }

    debugLog('[TiltCustomizer] applying template', {
      variantId: nextVariantId,
      templateKey: resolvedTemplate.key
    });
    return applyTemplate(resolvedTemplate, applyOptions);
  }

  function waitForSceneLoad() {
    if (!backendState.isSceneLoading || !sceneLoadPromise) {
      return Promise.resolve(true);
    }

    return sceneLoadPromise.then(function (result) {
      return result;
    });
  }

  function ensureCurrentVariantTemplateReady() {
    var ok = syncTemplateForVariant(getCurrentVariant(), { variantChanged: true });

    if (!ok) {
      return Promise.resolve(false);
    }

    return waitForSceneLoad().then(function (ready) {
      return ready && backendState.isCardTemplateLoading && cardTemplateLoadPromise
        ? cardTemplateLoadPromise : ready;
    });
  }

  function handleVariantChange(variant) {
    var nextVariant = variant || getCurrentVariant();
    var currentVariantId = currentVariant && currentVariant.id != null ? String(currentVariant.id) : null;
    var nextVariantId = nextVariant && nextVariant.id != null ? String(nextVariant.id) : null;
    var previousTemplateKey = currentTemplateKey;

    debugLog('[TiltCustomizer] variant sync', {
      currentVariantId: currentVariantId,
      nextVariantId: nextVariantId,
      nextVariantOptions: nextVariant && nextVariant.options ? nextVariant.options : null
    });

    syncTemplateForVariant(nextVariant, { variantChanged: true });

    if (nextVariantId && currentVariantId === nextVariantId && previousTemplateKey === currentTemplateKey) {
      return;
    }
  }
  function initVariantChangeIntegration() {
    function scheduleVariantSync() {
      if (variantSyncFrame) {
        window.cancelAnimationFrame(variantSyncFrame);
      }

      variantSyncFrame = window.requestAnimationFrame(function () {
        variantSyncFrame = null;
        handleVariantChange(getCurrentVariant());
      });
    }

    document.addEventListener('variant:change', function (event) {
      var variant = event && event.detail ? getVariantFromEventDetail(event.detail) : null;

      handleVariantChange(variant);
      scheduleVariantSync();
    });

    if (customizerRoot) {
      var productContainer = getProductContainer();

      productContainer.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-variant-input]')) {
          scheduleVariantSync();
        }
      });
    }
  }

  function updateSceneToggleState(template) {
    var toggle = customizerRoot ? customizerRoot.querySelector('[data-tilt-scene-toggle]') : null;
    var wrapper = toggle ? toggle.closest('.tilt-customizer__control') : null;
    var defaultSceneId = template ? template.defaultSceneId : null;
    var contextSceneId = template ? template.contextSceneId : null;
    var hasContextScene = !!(template && contextSceneId && template.scenes && template.scenes[contextSceneId]);

    if (!toggle || !wrapper) {
      return;
    }

    if (!hasContextScene || !defaultSceneId || defaultSceneId === contextSceneId) {
      wrapper.hidden = true;
      toggle.removeAttribute('data-scene-default');
      toggle.removeAttribute('data-scene-context');
      toggle.setAttribute('aria-pressed', 'false');
      toggle.classList.remove('is-active');
      return;
    }

    wrapper.hidden = false;
    toggle.setAttribute('data-scene-default', defaultSceneId);
    toggle.setAttribute('data-scene-context', contextSceneId);
    toggle.setAttribute('aria-pressed', state.scene === contextSceneId ? 'true' : 'false');
    toggle.classList.toggle('is-active', state.scene === contextSceneId);
  }

  function renderSceneControls(template) {
    updateSceneToggleState(template);
    renderCardTemplateControls(template);
  }

  function clearCardTemplate() {
    cardTemplateLoadToken += 1;
    backendState.isCardTemplateLoading = false;
    if (state.cardTemplateOverlay && canvas) {
      canvas.remove(state.cardTemplateOverlay);
      state.cardTemplateOverlay.dispose();
    }
    state.cardTemplateOverlay = null;
    state.cardTemplateId = null;
  }

  function renderCardTemplateControls(template) {
    var select = customizerRoot.querySelector('[data-tilt-card-template]');
    if (!select) { return; }
    var choices = template ? template.cardTemplates : [];
    var wrapper = select.closest('.tilt-customizer__control');
    wrapper.hidden = !choices.length;
    if (!choices.some(function (choice) { return choice.id === state.cardTemplateId; })) {
      clearCardTemplate();
    }
    while (select.options.length > 1) { select.remove(1); }
    choices.forEach(function (choice) {
      var option = document.createElement('option');
      option.value = choice.id;
      option.textContent = choice.label;
      select.appendChild(option);
    });
    select.value = state.cardTemplateId || '';
  }

  function placeCardTemplate(image, id) {
    var geometry = currentTemplate.cardTemplateGeometry;
    var choice = currentTemplate.cardTemplates.find(function (entry) { return entry.id === (id || state.cardTemplateId); });
    var width = geometry.printWidth;
    var height = geometry.printHeight;
    var border = geometry.border;
    var scaleX = printArea.width / (width - 2 * border) / geometry.mockScale;
    var scaleY = printArea.height / (height - 2 * border) / geometry.mockScale;
    image.set({
      originX: 'left', originY: 'top',
      left: printArea.left - printArea.width * border / (width - 2 * border) - geometry.mockLeft * scaleX,
      top: printArea.top - printArea.height * border / (height - 2 * border) - choice.mockTop * scaleY,
      scaleX: scaleX, scaleY: scaleY,
      selectable: false, evented: false,
      lockMovementX: true, lockMovementY: true,
      lockScalingX: true, lockScalingY: true, lockRotation: true
    });
    image.setCoords();
  }

  function setCardTemplate(id) {
    var select = customizerRoot.querySelector('[data-tilt-card-template]');
    var choice = currentTemplate.cardTemplates.find(function (entry) { return entry.id === id; });
    if (isCustomizerBusy() || (id && !choice)) {
      select.value = state.cardTemplateId || '';
      return Promise.resolve(false);
    }
    if ((id || null) === state.cardTemplateId) { return Promise.resolve(true); }
    var token = ++cardTemplateLoadToken;
    backendState.isCardTemplateLoading = true;
    setControlsDisabled(true);
    setUploadStatus(t('loadingCardTemplate'), 'loading');
    cardTemplateLoadPromise = (choice ? loadFabricImage(choice.url) : Promise.resolve(null))
      .then(function (image) {
        if (token !== cardTemplateLoadToken) {
          if (image) { image.dispose(); }
          return false;
        }
        if (image) { placeCardTemplate(image, id); }
        if (state.cardTemplateOverlay) {
          canvas.remove(state.cardTemplateOverlay);
          state.cardTemplateOverlay.dispose();
        }
        state.cardTemplateOverlay = image;
        state.cardTemplateId = id || null;
        if (image) { canvas.add(image); }
        restoreObjectOrder();
        invalidateGeneratedOutputsForTemplateChange();
        setCustomizerStatus(state.customerImage ? STATUS.EDITING : STATUS.IDLE, null);
        return true;
      })
      .catch(function (error) {
        if (token === cardTemplateLoadToken) {
          select.value = state.cardTemplateId || '';
          setUploadStatus(t('cardTemplateFailed'), 'error');
        }
        console.error('[TiltCustomizer] Card template could not be loaded.', error);
        return false;
      })
      .finally(function () {
        if (token === cardTemplateLoadToken) {
          backendState.isCardTemplateLoading = false;
          if (!isCustomizerBusy()) { setControlsDisabled(false); }
        }
      });
    return cardTemplateLoadPromise;
  }

  function applyTemplate(templateEntry, options) {
    var applyOptions = options || {};
    var previousTemplateKey = currentTemplateKey;

    if (!templateEntry || !templateEntry.template) {
      setUnsupportedTemplateState(getUnsupportedTemplateMessage());
      return false;
    }

    currentTemplate = normalizeTemplate(templateEntry);
    currentTemplateKey = currentTemplate.key;
    updateBackendPayloadTemplateFields();

    if (!validateConfig(config)) {
      setUnsupportedTemplateState(getUnsupportedTemplateMessage());
      return false;
    }

    if (previousTemplateKey && previousTemplateKey !== currentTemplateKey) {
      if (hasReusableUploadedArtwork()) {
        invalidateGeneratedOutputsForTemplateChange();
      } else {
        resetBackendStateForTemplateChange();
      }
    }

    renderSceneControls(currentTemplate);

    canvasWidth = currentTemplate.canvas.width;
    canvasHeight = currentTemplate.canvas.height;
    state.scene = config.scenes[state.scene] ? state.scene : currentTemplate.defaultSceneId;
    printArea = config.scenes[state.scene].printArea;

    if (!canvas) {
      return true;
    }

    sceneLoadPromise = setScene(state.scene);
    syncCanvasDisplaySize(true);

    if (state.customerImage && applyOptions.variantChanged) {
      invalidateGeneratedOutputsForTemplateChange();
      centerCustomerImage(state.customerImage, 'contain');
      restoreObjectOrder();
      canvas.setActiveObject(state.customerImage);
      canvas.requestRenderAll();

      if (hasReusableUploadedArtwork()) {
        setCustomizerStatus(STATUS.EDITING, null);
      } else {
        setCustomizerStatus(STATUS.IDLE, t('sizeChangedUploadAgain'), 'error');
      }
    } else {
      setCustomizerStatus(STATUS.IDLE, null);
    }

    setControlsDisabled(false);
    return true;
  }

  function syncCanvasDisplaySize(force) {
    var canvasElement = document.getElementById(CANVAS_ID);
    var canvasStage = canvasElement && canvasElement.closest('.tilt-customizer__canvas-stage');

    if (!canvas || !canvasStage) {
      return;
    }

    var stageWidth = Math.round(canvasStage.clientWidth);
    var stageHeight = Math.round(canvasStage.clientHeight);

    if (!stageWidth || !stageHeight) {
      return;
    }

    var scale = Math.min(stageWidth / canvasWidth, stageHeight / canvasHeight);
    var offsetX = (stageWidth - (canvasWidth * scale)) / 2;
    var offsetY = (stageHeight - (canvasHeight * scale)) / 2;
    var signature = [
      stageWidth,
      stageHeight,
      canvasWidth,
      canvasHeight,
      scale.toFixed(6),
      offsetX.toFixed(3),
      offsetY.toFixed(3)
    ].join(':');

    if (!force && signature === canvasDisplaySignature) {
      canvas.calcOffset();
      scheduleGestureOverlaySync();
      return;
    }

    canvasDisplaySignature = signature;

    if (canvas.getWidth() !== stageWidth || canvas.getHeight() !== stageHeight) {
      canvas.setDimensions({
        width: stageWidth,
        height: stageHeight
      });
    }

    canvas.setViewportTransform([scale, 0, 0, scale, offsetX, offsetY]);
    canvas.calcOffset();
    canvas.requestRenderAll();
    scheduleGestureOverlaySync();
  }

  function scheduleCanvasDisplaySizeSync() {
    if (resizeFrame) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      syncCanvasDisplaySize();
    });
  }

  function loadFabricImage(url) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        reject(new Error('Image URL is required.'));
        return;
      }

      if (window.fabric.util && typeof window.fabric.util.loadImage === 'function') {
        window.fabric.util.loadImage(
          url,
          function (image, isError) {
            if (isError || !image) {
              reject(new Error('Image load failed: ' + url));
              return;
            }

            resolve(new window.fabric.Image(image));
          },
          null,
          'anonymous'
        );
        return;
      }

      window.fabric.Image.fromURL(
        url,
        function (image) {
          if (!image) {
            reject(new Error('Image load failed: ' + url));
            return;
          }

          resolve(image);
        },
        { crossOrigin: 'anonymous' }
      );
    });
  }

  function scaleToCanvasWidth(image) {
    if (!image || !image.width) {
      return;
    }

    image.scaleToWidth(canvasWidth);
    image.set({
      left: 0,
      top: 0
    });
  }

  function parseLayerPlacementNumber(value, name) {
    var number = Number(value);

    if (!isFinite(number)) {
      throw new Error('[TiltCustomizer] Invalid layer placement value: ' + name + '.');
    }

    return number;
  }

  function placeCanvasRectLayer(image, placement) {
    var left = parseLayerPlacementNumber(placement.left, 'left');
    var top = parseLayerPlacementNumber(placement.top, 'top');
    var scale = null;

    if (placement.width !== undefined) {
      var width = parseLayerPlacementNumber(placement.width, 'width');

      if (width <= 0) {
        throw new Error('[TiltCustomizer] Layer placement width must be greater than zero.');
      }

      scale = width / image.width;
    } else if (placement.height !== undefined) {
      var height = parseLayerPlacementNumber(placement.height, 'height');

      if (height <= 0) {
        throw new Error('[TiltCustomizer] Layer placement height must be greater than zero.');
      }

      scale = height / image.height;
    } else {
      throw new Error('[TiltCustomizer] Layer placement requires width or height.');
    }

    image.set({
      originX: 'left',
      originY: 'top',
      left: left,
      top: top,
      scaleX: scale,
      scaleY: scale
    });
    image.setCoords();
  }

  function placeLayer(image, layerConfig, sceneConfig) {
    var placement = layerConfig && layerConfig.placement ? layerConfig.placement : null;
    var area = sceneConfig && sceneConfig.printArea ? sceneConfig.printArea : printArea;

    if (!image || !image.width || !image.height) {
      return;
    }

    if (!placement) {
      scaleToCanvasWidth(image);
      return;
    }

    if (placement.target === 'canvasRect') {
      placeCanvasRectLayer(image, placement);
      return;
    }

    if (placement.target !== 'printArea') {
      throw new Error('[TiltCustomizer] Unsupported layer placement target: ' + placement.target + '.');
    }

    if (!area) {
      throw new Error('[TiltCustomizer] Layer placement target printArea is missing.');
    }

    var scale = placement.fit === 'contain'
      ? Math.min(area.width / image.width, area.height / image.height)
      : Math.max(area.width / image.width, area.height / image.height);

    var layerOptions = {
      originX: 'center',
      originY: 'center',
      left: area.left + (area.width / 2),
      top: area.top + (area.height / 2),
      scaleX: scale,
      scaleY: scale
    };

    if (placement.clip === true) {
      layerOptions.clipPath = new window.fabric.Rect({
        left: area.left,
        top: area.top,
        width: area.width,
        height: area.height,
        absolutePositioned: true
      });
    }

    image.set(layerOptions);
    image.setCoords();
  }

  function restoreObjectOrder() {
    if (state.customerImage) {
      canvas.sendToBack(state.customerImage);
    }

    if (state.cardTemplateOverlay) {
      placeCardTemplate(state.cardTemplateOverlay);
      state.cardTemplateOverlay.bringToFront();
    }

    if (state.mockupBase) {
      state.mockupBase.bringToFront();
    }

    state.sceneLayers.forEach(function (layer) {
      layer.bringToFront();
    });

    canvas.requestRenderAll();
  }

  function removeSceneObjects() {
    if (state.mockupBase) {
      canvas.remove(state.mockupBase);
      state.mockupBase = null;
    }

    state.sceneLayers.forEach(function (layer) {
      canvas.remove(layer);
    });
    state.sceneLayers = [];
  }

  function setScene(scene) {
    if (!config.scenes || !config.scenes[scene]) {
      return Promise.resolve(false);
    }

    sceneLoadToken += 1;
    var currentSceneLoadToken = sceneLoadToken;
    var sceneConfig = config.scenes[scene];
    var mockupUrl = sceneConfig.mockupUrl;

    state.scene = scene;
    printArea = sceneConfig.printArea;
    backendState.isSceneLoading = true;
    updateSceneToggleState(currentTemplate);

    return loadFabricImage(mockupUrl)
      .then(function (mockupImage) {
        if (mockupImage) {
          mockupImage.set({
            selectable: false,
            evented: false
          });
          scaleToCanvasWidth(mockupImage);
        }

        return Promise.all(sceneConfig.layers.map(function (layerConfig) {
          return loadFabricImage(layerConfig.url).then(function (layerImage) {
            layerImage.set({
              selectable: false,
              evented: false
            });
            placeLayer(layerImage, layerConfig, sceneConfig);

            return layerImage;
          });
        })).then(function (layerImages) {
          return {
            mockupImage: mockupImage,
            layerImages: layerImages
          };
        });
      })
      .then(function (sceneObjects) {
        if (currentSceneLoadToken !== sceneLoadToken) {
          return false;
        }

        removeSceneObjects();
        state.mockupBase = sceneObjects.mockupImage;
        state.sceneLayers = sceneObjects.layerImages;

        if (state.mockupBase) {
          canvas.add(state.mockupBase);
        }

        state.sceneLayers.forEach(function (layerImage) {
          canvas.add(layerImage);
        });

        restoreObjectOrder();
        return true;
      })
      .catch(function (error) {
        console.error('[TiltCustomizer] Could not load required scene image.', error);
        if (currentSceneLoadToken === sceneLoadToken) {
          setCustomizerStatus(STATUS.IDLE, t('missingMockupForVariant'), 'error');
        }
        restoreObjectOrder();
        return false;
      })
      .then(function (result) {
        if (currentSceneLoadToken === sceneLoadToken) {
          backendState.isSceneLoading = false;

        }

        return result;
      });
  }

  function getCustomerImageFitOverscanValue(value, fallback) {
    return hasNumber(value) && value > 0 ? value : fallback;
  }

  function getCustomerImageFitOverscan() {
    var configuredOverscan = currentTemplate && currentTemplate.customerImageFitOverscan
      ? currentTemplate.customerImageFitOverscan
      : {};

    return {
      x: getCustomerImageFitOverscanValue(configuredOverscan.x, DEFAULT_CUSTOMER_IMAGE_FIT_OVERSCAN_X),
      y: getCustomerImageFitOverscanValue(configuredOverscan.y, DEFAULT_CUSTOMER_IMAGE_FIT_OVERSCAN_Y)
    };
  }
  function centerCustomerImage(image, fitMode) {
    var fitOverscan = getCustomerImageFitOverscan();
    var targetWidth = printArea.width * fitOverscan.x;
    var targetHeight = printArea.height * fitOverscan.y;

    image.set({
      originX: 'center',
      originY: 'center',
      left: printArea.left + (printArea.width / 2),
      top: printArea.top + (printArea.height / 2),
      selectable: true,
      evented: true
    });

    if (image.width && image.height) {
      var scale = fitMode === 'contain'
        ? Math.min(targetWidth / image.width, targetHeight / image.height)
        : Math.max(targetWidth / image.width, targetHeight / image.height);

      image.set({
        scaleX: scale,
        scaleY: scale
      });
    }

    image.setCoords();
  }

  function validateImageFile(file) {
    var fileName = file && file.name ? String(file.name).toLowerCase() : '';
    var hasValidExtension = VALID_FILE_EXTENSIONS.some(function (extension) {
      return fileName.endsWith(extension);
    });

    if (!file || VALID_MIME_TYPES.indexOf(file.type) === -1 || !hasValidExtension) {
      setCustomizerStatus(STATUS.IDLE, t('invalidFileType'), 'error');
      focusCustomizerStatus();
      return false;
    }

    if (file.size > getMaxFileBytes()) {
      setCustomizerStatus(STATUS.IDLE, t('fileTooLargePrefix') + getMaxFileMegabytes() + t('fileTooLargeSuffix'), 'error');
      focusCustomizerStatus();
      return false;
    }

    return true;
  }

  function addCustomerImageFromFile(file) {
    var objectUrl = URL.createObjectURL(file);

    return loadFabricImage(objectUrl)
      .then(function (image) {
        URL.revokeObjectURL(objectUrl);

        return image;
      })
      .then(function (image) {
        if (!image) {
          return;
        }

        if (state.customerImage) {
          canvas.remove(state.customerImage);
        }

        centerCustomerImage(image);
        state.customerImage = image;
        canvas.add(image);
        restoreObjectOrder();
        canvas.setActiveObject(image);
        canvas.requestRenderAll();
        backendState.hasUploadedArtwork = true;
        backendState.thumbnailUrl = null;
        backendState.productionUrl = null;
        backendState.upscaledOriginalUrl = null;
        backendState.upscaledProductionUrl = null;
        debugLog('[TiltCustomizer] customer image loaded.');
      })
      .catch(function (error) {
        URL.revokeObjectURL(objectUrl);
        throw error;
      });
  }

  function uploadOriginalWithBackend(file) {
    var uploadStartedAt = Date.now();
    var uploadStepStartedAt = uploadStartedAt;
    var uploadAttemptId = createTelemetryId('upl');
    var uploadAttemptSeq = uploadTelemetryAttemptSequence + 1;
    var uploadStep = 'initialized';
    var uploadAssetId = null;
    var uploadMethod = null;
    var uploadHost = null;
    var fileTelemetryData = getFileTelemetryData(file);

    uploadTelemetryAttemptSequence = uploadAttemptSeq;
    backendState.isUploading = true;
    backendState.hasUploadedArtwork = false;
    backendState.thumbnailUrl = null;
    backendState.productionUrl = null;
    backendState.upscaledOriginalUrl = null;
    backendState.upscaledProductionUrl = null;
    setControlsDisabled(true);
    setCustomizerStatus(STATUS.UPLOADING, t('uploadingArtwork'), 'loading');

    function uploadTelemetryData(extra) {
      return Object.assign({
        uploadAttemptId: uploadAttemptId,
        uploadAttemptSeq: uploadAttemptSeq,
        uploadStep: uploadStep,
        uploadAssetId: uploadAssetId,
        uploadMethod: uploadMethod,
        uploadHost: uploadHost
      }, fileTelemetryData, extra || {});
    }

    function markUploadStep(step, extra) {
      var now = Date.now();
      uploadStep = step;
      trackTelemetryEvent('frontend_upload_step', uploadTelemetryData(Object.assign({
        uploadStep: step,
        durationMs: now - uploadStartedAt,
        stepDurationMs: now - uploadStepStartedAt
      }, extra || {})));
      uploadStepStartedAt = now;
    }

    markUploadStep('design_ensure_started');

    return ensureDesign()
      .then(function () {
        markUploadStep('design_ready');
        trackTelemetryEvent('frontend_upload_file_selected', uploadTelemetryData({ uploadStep: 'file_selected' }));
        trackTelemetryEvent('frontend_upload_started', uploadTelemetryData({ uploadStep: 'started' }));
        markUploadStep('upload_url_requested');
        return requestUploadUrl(file);
      })
      .then(function (response) {
        if (response && response.assetId) {
          uploadAssetId = String(response.assetId);
        }

        if (response && response.upload) {
          uploadMethod = response.upload.method ? String(response.upload.method) : null;
          uploadHost = getUploadHost(response.upload.url);
        }

        markUploadStep('upload_url_received');

        if (!response || !response.assetId || !response.upload) {
          throw new Error('[TiltCustomizer] API response did not include assetId/upload.');
        }

        markUploadStep('storage_upload_started');

        return uploadToStorage(file, response.upload)
          .then(function () {
            markUploadStep('storage_upload_completed');
            markUploadStep('complete_upload_started');
            return completeUpload(response.assetId);
          })
          .then(function (completion) {
            markUploadStep('complete_upload_completed');
            backendState.originalAssetId = response.assetId;
            backendState.uploadedAssetId = response.assetId;
            backendState.originalUrl = completion && completion.publicUrl ? completion.publicUrl : null;
            markUploadStep('canvas_load_started');
            return addCustomerImageFromFile(file);
          })
          .then(function () {
            markUploadStep('canvas_load_completed');
          });
      })
      .then(function () {
        backendState.isUploading = false;
        setControlsDisabled(false);
        syncDeferredCustomizerProperties(getCurrentProductForm());
        trackTelemetryEvent('frontend_upload_completed', uploadTelemetryData({
          uploadStep: 'completed',
          durationMs: Date.now() - uploadStartedAt
        }));
        setCustomizerStatus(STATUS.UPLOAD_COMPLETED, null);
      })
      .catch(function (error) {
        backendState.isUploading = false;
        backendState.hasUploadedArtwork = false;
        backendState.originalAssetId = null;
        backendState.uploadedAssetId = null;
        backendState.thumbnailUrl = null;
        backendState.originalUrl = null;
        backendState.productionUrl = null;
        backendState.upscaledOriginalUrl = null;
        backendState.upscaledProductionUrl = null;
        setControlsDisabled(false);
        trackTelemetryEvent('frontend_upload_failed', Object.assign(uploadTelemetryData({
          durationMs: Date.now() - uploadStartedAt
        }), getErrorTelemetryData(error)));
        setCustomizerStatus(STATUS.UPLOAD_FAILED, t('uploadFailed'), 'error');
        throw error;
      });
  }
  function handleUploadChange(event) {
    var file = event.target.files && event.target.files[0];

    if (!file) {
      return;
    }

    if (!currentTemplate) {
      event.target.value = '';
      setCustomizerStatus(STATUS.IDLE, getUnsupportedTemplateMessage(), 'error');
      focusCustomizerStatus();
      return;
    }

    if (isCustomizerBusy()) {
      event.target.value = '';
      trackTelemetryEvent('frontend_upload_blocked_busy', { reason: 'customizer_busy' });
      setCustomizerStatus(backendState.status, t('uploadAlreadyInProgress'), 'loading');
      return;
    }

    if (!validateImageFile(file)) {
      event.target.value = '';
      return;
    }

    backendState.thumbnailUrl = null;
    backendState.originalUrl = null;
    backendState.productionUrl = null;
    backendState.upscaledOriginalUrl = null;
    backendState.upscaledProductionUrl = null;
    backendState.originalAssetId = null;
    backendState.uploadedAssetId = null;
    backendState.hasUploadedArtwork = false;
    setCustomizerStatus(STATUS.FILE_SELECTED, t('fileSelected'), 'loading');

    var flow = config.backendEnabled === true
      ? uploadOriginalWithBackend(file)
      : addCustomerImageFromFile(file).then(function () {
        setCustomizerStatus(STATUS.EDITING, null);
      });

    flow
      .catch(function (error) {
        console.error('[TiltCustomizer] Could not process uploaded image.', error);
        if (config.backendEnabled !== true) {
          backendState.hasUploadedArtwork = false;
          setCustomizerStatus(STATUS.UPLOAD_FAILED, t('genericUploadProcessingFailed'), 'error');
        }
        event.target.value = '';
      });
  }
  function exportState() {
    var customerImage = null;

    if (state.customerImage) {
      customerImage = {
        left: state.customerImage.left,
        top: state.customerImage.top,
        scaleX: state.customerImage.scaleX,
        scaleY: state.customerImage.scaleY,
        angle: state.customerImage.angle,
        width: state.customerImage.width,
        height: state.customerImage.height
      };
    }

    return {
      templateKey: currentTemplateKey,
      templateId: config.templateId,
      templateVersion: config.templateVersion,
      productId: config.productId,
      variantId: config.variantId,
      sessionId: sessionId,
      scene: state.scene,
      cardTemplateId: state.cardTemplateId,
      printArea: printArea,
      customerImage: customerImage
    };
  }

  function getPointerDistance(firstPointer, secondPointer) {
    var deltaX = secondPointer.x - firstPointer.x;
    var deltaY = secondPointer.y - firstPointer.y;

    return Math.sqrt((deltaX * deltaX) + (deltaY * deltaY));
  }

  function shouldUseCustomTouchGestures() {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      return true;
    }

    return window.innerWidth <= 768;
  }

  function applyCanvasTouchAction() {
    if (!canvas) {
      return;
    }

    var useCustomTouchGestures = shouldUseCustomTouchGestures();

    [canvas.wrapperEl, canvas.upperCanvasEl, canvas.lowerCanvasEl].forEach(function (element) {
      if (element && element.style) {
        element.style.touchAction = 'pan-y';
      }
    });

    [canvas.upperCanvasEl, canvas.lowerCanvasEl].forEach(function (element) {
      if (element && element.style) {
        element.style.pointerEvents = useCustomTouchGestures ? 'none' : '';
      }
    });

    syncGestureOverlay();
  }

  function ensureGestureOverlay() {
    if (!canvas || !canvas.wrapperEl) {
      return null;
    }

    if (gestureOverlay && gestureOverlay.parentNode === canvas.wrapperEl) {
      return gestureOverlay;
    }

    gestureOverlay = document.createElement('div');
    gestureOverlay.className = 'tilt-customizer__gesture-overlay';
    gestureOverlay.setAttribute('aria-hidden', 'true');
    gestureOverlay.style.left = '0px';
    gestureOverlay.style.top = '0px';
    canvas.wrapperEl.appendChild(gestureOverlay);
    return gestureOverlay;
  }

  function getCanvasViewportMetrics() {
    var canvasElement = canvas && canvas.upperCanvasEl ? canvas.upperCanvasEl : null;

    if (!canvas || !canvasElement) {
      return null;
    }

    var rect = canvasElement.getBoundingClientRect();
    var transform = canvas.viewportTransform || [1, 0, 0, 1, 0, 0];

    if (!rect.width || !rect.height || !transform[0] || !transform[3]) {
      return null;
    }

    return {
      rect: rect,
      scaleX: transform[0],
      scaleY: transform[3],
      offsetX: transform[4],
      offsetY: transform[5]
    };
  }

  function getCustomerImageCanvasRect() {
    if (!state.customerImage || !canvasWidth || !canvasHeight) {
      return null;
    }

    state.customerImage.setCoords();
    var imageRect = state.customerImage.getBoundingRect(true, true);
    var left = Math.max(imageRect.left, 0);
    var top = Math.max(imageRect.top, 0);
    var right = Math.min(imageRect.left + imageRect.width, canvasWidth);
    var bottom = Math.min(imageRect.top + imageRect.height, canvasHeight);

    if (right <= left || bottom <= top) {
      return null;
    }

    return {
      left: left,
      top: top,
      width: right - left,
      height: bottom - top
    };
  }

  function expandGestureOverlayAxis(start, size, minimumSize, minimumBound, maximumBound) {
    var availableSize = maximumBound - minimumBound;
    var targetSize = Math.min(minimumSize, availableSize);

    if (targetSize <= 0 || size >= targetSize) {
      return {
        start: start,
        size: size
      };
    }

    var center = start + (size / 2);
    var expandedStart = center - (targetSize / 2);

    if (expandedStart < minimumBound) {
      expandedStart = minimumBound;
    }

    if (expandedStart + targetSize > maximumBound) {
      expandedStart = maximumBound - targetSize;
    }

    return {
      start: Math.round(expandedStart),
      size: Math.round(targetSize)
    };
  }

  function hideGestureOverlay(overlay) {
    if (!overlay) {
      return;
    }

    if (!overlay.hidden) {
      overlay.hidden = true;
    }

    gestureOverlaySignature = 'hidden';
  }

  function syncGestureOverlay() {
    if (!gestureOverlay && (!canvas || !canvas.wrapperEl)) {
      return;
    }

    var overlay = ensureGestureOverlay();

    if (!overlay) {
      return;
    }

    if (!shouldUseCustomTouchGestures() || !state.customerImage) {
      hideGestureOverlay(overlay);
      return;
    }

    var metrics = getCanvasViewportMetrics();
    var customerImageRect = getCustomerImageCanvasRect();

    if (!metrics || !customerImageRect) {
      hideGestureOverlay(overlay);
      return;
    }

    var left = Math.round(metrics.offsetX + (customerImageRect.left * metrics.scaleX));
    var top = Math.round(metrics.offsetY + (customerImageRect.top * metrics.scaleY));
    var width = Math.round(customerImageRect.width * metrics.scaleX);
    var height = Math.round(customerImageRect.height * metrics.scaleY);
    var canvasLeft = Math.round(metrics.offsetX);
    var canvasTop = Math.round(metrics.offsetY);
    var canvasRight = Math.round(metrics.offsetX + (canvasWidth * metrics.scaleX));
    var canvasBottom = Math.round(metrics.offsetY + (canvasHeight * metrics.scaleY));
    var expandedX = expandGestureOverlayAxis(left, width, MIN_GESTURE_TARGET_SIZE, canvasLeft, canvasRight);
    var expandedY = expandGestureOverlayAxis(top, height, MIN_GESTURE_TARGET_SIZE, canvasTop, canvasBottom);

    left = expandedX.start;
    width = expandedX.size;
    top = expandedY.start;
    height = expandedY.size;

    var signature = [left, top, width, height].join(':');

    if (gestureOverlaySignature === signature && !overlay.hidden) {
      return;
    }

    gestureOverlaySignature = signature;

    if (overlay.hidden) {
      overlay.hidden = false;
    }

    overlay.style.transform = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    overlay.style.width = width + 'px';
    overlay.style.height = height + 'px';
  }

  function scheduleGestureOverlaySync() {
    if (gestureOverlayFrame) {
      return;
    }

    gestureOverlayFrame = window.requestAnimationFrame(function () {
      gestureOverlayFrame = null;
      syncGestureOverlay();
    });
  }

  function getCanvasGestureTarget() {
    return ensureGestureOverlay();
  }

  function getCanvasPointFromClient(clientX, clientY) {
    var canvasElement = canvas && canvas.upperCanvasEl ? canvas.upperCanvasEl : null;

    if (!canvasElement || typeof clientX !== 'number' || typeof clientY !== 'number') {
      return null;
    }

    var rect = canvasElement.getBoundingClientRect();
    if (!rect.width || !rect.height) {
      return null;
    }

    var canvasX = (clientX - rect.left) * (canvas.getWidth() / rect.width);
    var canvasY = (clientY - rect.top) * (canvas.getHeight() / rect.height);
    var transform = canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
    var determinant = (transform[0] * transform[3]) - (transform[1] * transform[2]);

    if (!determinant) {
      return null;
    }

    return {
      x: ((transform[3] * (canvasX - transform[4])) - (transform[2] * (canvasY - transform[5]))) / determinant,
      y: ((-transform[1] * (canvasX - transform[4])) + (transform[0] * (canvasY - transform[5]))) / determinant
    };
  }

  function getCanvasPointFromEvent(event) {
    if (!event) {
      return null;
    }

    return getCanvasPointFromClient(event.clientX, event.clientY);
  }

  function isPointInsideCustomerGestureTarget(point) {
    if (!state.customerImage || !point || !canvasWidth || !canvasHeight) {
      return false;
    }

    return point.x >= 0
      && point.x <= canvasWidth
      && point.y >= 0
      && point.y <= canvasHeight;
  }

  function preventNativeScroll(event) {
    if (!event) {
      return;
    }

    if (event.cancelable !== false && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
  }

  function preventNativeTouchHandling(event) {
    preventNativeScroll(event);

    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
  }

  function getTouchPointsFromEvent(event) {
    if (!event || !event.touches || event.touches.length !== 2) {
      return [];
    }

    return Array.prototype.map.call(event.touches, function (touch) {
      var point = getCanvasPointFromClient(touch.clientX, touch.clientY);

      if (!point) {
        return null;
      }

      return {
        id: touch.identifier,
        x: point.x,
        y: point.y
      };
    }).filter(Boolean);
  }

  function getTouchPointerEntries() {
    return Object.keys(activeTouchPointers).map(function (pointerId) {
      return activeTouchPointers[pointerId];
    });
  }

  function findPointById(points, pointId) {
    for (var index = 0; index < points.length; index += 1) {
      if (points[index].id === pointId) {
        return points[index];
      }
    }

    return null;
  }

  function beginPinchGestureFromPoints(points, event) {
    if (activePinchGesture || points.length !== 2 || !state.customerImage) {
      return false;
    }

    if (!isPointInsideCustomerGestureTarget(points[0]) || !isPointInsideCustomerGestureTarget(points[1])) {
      return false;
    }

    var distance = getPointerDistance(points[0], points[1]);
    if (distance <= 0) {
      return false;
    }

    activePinchGesture = {
      pointerIds: [points[0].id, points[1].id],
      object: state.customerImage,
      startDistance: distance,
      startScaleX: state.customerImage.scaleX || 1,
      startScaleY: state.customerImage.scaleY || 1
    };

    canvas.setActiveObject(state.customerImage);
    preventNativeTouchHandling(event);
    return true;
  }

  function updatePinchGestureFromPoints(points, event) {
    if (!activePinchGesture || !activePinchGesture.object) {
      return false;
    }

    var firstPointer = findPointById(points, activePinchGesture.pointerIds[0]);
    var secondPointer = findPointById(points, activePinchGesture.pointerIds[1]);

    if (!firstPointer || !secondPointer) {
      activePinchGesture = null;
      return false;
    }

    var distance = getPointerDistance(firstPointer, secondPointer);
    if (distance <= 0) {
      return false;
    }

    var scaleRatio = distance / activePinchGesture.startDistance;
    activePinchGesture.object.set({
      scaleX: activePinchGesture.startScaleX * scaleRatio,
      scaleY: activePinchGesture.startScaleY * scaleRatio
    });
    activePinchGesture.object.setCoords();
    invalidateGeneratedOutputsForTemplateChange();
    restoreObjectOrder();
    canvas.setActiveObject(activePinchGesture.object);
    canvas.requestRenderAll();
    preventNativeTouchHandling(event);
    return true;
  }

  function endTouchPointer(pointerId) {
    var hadPinchGesture = !!activePinchGesture;

    delete activeTouchPointers[pointerId];

    if (!activePinchGesture) {
      return;
    }

    if (activePinchGesture.pointerIds.indexOf(pointerId) !== -1 || getTouchPointerEntries().length < 2) {
      activePinchGesture = null;

    }
  }

  function getSingleTouchPointFromEvent(event) {
    if (!event || !event.touches || event.touches.length !== 1) {
      return null;
    }

    var touch = event.touches[0];
    var point = getCanvasPointFromClient(touch.clientX, touch.clientY);

    if (!point) {
      return null;
    }

    return {
      id: touch.identifier,
      x: point.x,
      y: point.y
    };
  }

  function findTouchPointInEvent(event, touchId) {
    if (!event || !event.touches) {
      return null;
    }

    for (var index = 0; index < event.touches.length; index += 1) {
      if (event.touches[index].identifier === touchId) {
        var touch = event.touches[index];
        var point = getCanvasPointFromClient(touch.clientX, touch.clientY);

        if (!point) {
          return null;
        }

        return {
          id: touch.identifier,
          x: point.x,
          y: point.y
        };
      }
    }

    return null;
  }

  function beginTouchDragGesture(event) {
    var point = getSingleTouchPointFromEvent(event);

    if (!point || !isPointInsideCustomerGestureTarget(point)) {
      return false;
    }

    activeTouchDragGesture = {
      pointerId: point.id,
      object: state.customerImage,
      startX: point.x,
      startY: point.y,
      startLeft: state.customerImage.left || 0,
      startTop: state.customerImage.top || 0
    };

    canvas.setActiveObject(state.customerImage);
    preventNativeTouchHandling(event);
    return true;
  }

  function updateTouchDragGesture(event) {
    if (!activeTouchDragGesture || !activeTouchDragGesture.object) {
      return false;
    }

    var point = findTouchPointInEvent(event, activeTouchDragGesture.pointerId);

    if (!point) {
      activeTouchDragGesture = null;
      return false;
    }

    activeTouchDragGesture.object.set({
      left: activeTouchDragGesture.startLeft + (point.x - activeTouchDragGesture.startX),
      top: activeTouchDragGesture.startTop + (point.y - activeTouchDragGesture.startY)
    });
    activeTouchDragGesture.object.setCoords();
    invalidateGeneratedOutputsForTemplateChange();
    restoreObjectOrder();
    canvas.setActiveObject(activeTouchDragGesture.object);
    canvas.requestRenderAll();
    preventNativeTouchHandling(event);
    return true;
  }

  function endTouchDragGesture(event) {
    if (!activeTouchDragGesture) {
      return;
    }

    if (!findTouchPointInEvent(event, activeTouchDragGesture.pointerId)) {
      activeTouchDragGesture = null;
    }
  }

  function bindTouchPinchScaling(gestureTarget) {
    var listenerOptions = { passive: false, capture: true };

    gestureTarget.addEventListener('touchstart', function (event) {
      var points = getTouchPointsFromEvent(event);

      if (points.length === 2) {
        activeTouchDragGesture = null;
        beginPinchGestureFromPoints(points, event);
        return;
      }

      beginTouchDragGesture(event);
    }, listenerOptions);

    gestureTarget.addEventListener('touchmove', function (event) {
      var points = getTouchPointsFromEvent(event);

      if (points.length === 2) {
        activeTouchDragGesture = null;

        if (!activePinchGesture) {
          beginPinchGestureFromPoints(points, event);
        }

        if (activePinchGesture) {
          updatePinchGestureFromPoints(points, event);
        }

        return;
      }

      updateTouchDragGesture(event);
    }, listenerOptions);

    ['touchend', 'touchcancel'].forEach(function (eventName) {
      gestureTarget.addEventListener(eventName, function (event) {
        endTouchDragGesture(event);

        if (!event.touches || event.touches.length < 2) {
          activePinchGesture = null;
        }
      }, listenerOptions);
    });
  }
  function bindPointerPinchScaling(gestureTarget) {
    var listenerOptions = { passive: false, capture: true };

    if (!window.PointerEvent) {
      return;
    }

    gestureTarget.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'touch') {
        return;
      }

      var pointer = getCanvasPointFromEvent(event);
      if (!pointer) {
        return;
      }

      activeTouchPointers[event.pointerId] = {
        id: event.pointerId,
        x: pointer.x,
        y: pointer.y
      };

      if (typeof gestureTarget.setPointerCapture === 'function') {
        gestureTarget.setPointerCapture(event.pointerId);
      }

      beginPinchGestureFromPoints(getTouchPointerEntries(), event);
    }, listenerOptions);

    gestureTarget.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'touch' || !activeTouchPointers[event.pointerId]) {
        return;
      }

      var pointer = getCanvasPointFromEvent(event);
      if (!pointer) {
        return;
      }

      activeTouchPointers[event.pointerId].x = pointer.x;
      activeTouchPointers[event.pointerId].y = pointer.y;

      if (activePinchGesture) {
        updatePinchGestureFromPoints(getTouchPointerEntries(), event);
      }
    }, listenerOptions);

    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (eventName) {
      gestureTarget.addEventListener(eventName, function (event) {
        endTouchPointer(event.pointerId);
      }, listenerOptions);
    });
  }

  function isElementInsideGestureOverlay(element) {
    return !!(gestureOverlay && element && typeof gestureOverlay.contains === 'function' && gestureOverlay.contains(element));
  }

  function isPointInsideCanvasBounds(point) {
    return !!point
      && point.x >= 0
      && point.x <= canvasWidth
      && point.y >= 0
      && point.y <= canvasHeight;
  }

  function discardActiveCustomerImageSelection() {
    if (!canvas || canvas.getActiveObject() !== state.customerImage) {
      return false;
    }

    canvas.discardActiveObject();
    canvas.requestRenderAll();
    return true;
  }

  function bindMobileCanvasDeselect() {
    if (!canvas || !canvas.wrapperEl || !window.TouchEvent) {
      return;
    }

    canvas.wrapperEl.addEventListener('touchstart', function (event) {
      if (!shouldUseCustomTouchGestures() || !state.customerImage || !event.touches || event.touches.length !== 1) {
        mobileDeselectTap = null;
        return;
      }

      if (isElementInsideGestureOverlay(event.target)) {
        mobileDeselectTap = null;
        return;
      }

      var touch = event.touches[0];
      var point = getCanvasPointFromClient(touch.clientX, touch.clientY);

      if (!isPointInsideCanvasBounds(point)) {
        mobileDeselectTap = null;
        return;
      }

      mobileDeselectTap = {
        identifier: touch.identifier,
        startClientX: touch.clientX,
        startClientY: touch.clientY,
        moved: false,
        startedAt: Date.now()
      };
    }, { passive: true, capture: false });

    canvas.wrapperEl.addEventListener('touchmove', function (event) {
      if (!mobileDeselectTap || !event.touches) {
        return;
      }

      for (var index = 0; index < event.touches.length; index += 1) {
        if (event.touches[index].identifier === mobileDeselectTap.identifier) {
          var dx = event.touches[index].clientX - mobileDeselectTap.startClientX;
          var dy = event.touches[index].clientY - mobileDeselectTap.startClientY;

          if (Math.sqrt((dx * dx) + (dy * dy)) > MOBILE_DESELECT_TAP_MOVE_THRESHOLD) {
            mobileDeselectTap.moved = true;
          }

          return;
        }
      }
    }, { passive: true, capture: false });

    canvas.wrapperEl.addEventListener('touchend', function (event) {
      if (!mobileDeselectTap) {
        return;
      }

      var tap = mobileDeselectTap;
      mobileDeselectTap = null;

      if (tap.moved || Date.now() - tap.startedAt > MOBILE_DESELECT_TAP_MAX_DURATION) {
        return;
      }

      if (isElementInsideGestureOverlay(event.target)) {
        return;
      }

      discardActiveCustomerImageSelection();
    }, { passive: true, capture: false });

    canvas.wrapperEl.addEventListener('touchcancel', function () {
      mobileDeselectTap = null;
    }, { passive: true, capture: false });
  }
  function bindCanvasTouchScaling() {
    var gestureTarget = getCanvasGestureTarget();

    if (!gestureTarget) {
      return;
    }

    if ('ontouchstart' in window || window.TouchEvent) {
      bindTouchPinchScaling(gestureTarget);
      return;
    }

    bindPointerPinchScaling(gestureTarget);
  }
  function bindEvents(root) {
    var cardTemplateSelect = root.querySelector('[data-tilt-card-template]');
    if (cardTemplateSelect) {
      cardTemplateSelect.addEventListener('change', function () {
        setCardTemplate(cardTemplateSelect.value);
      });
    }
    var sceneToggle = root.querySelector('[data-tilt-scene-toggle]');

    if (sceneToggle) {
      sceneToggle.addEventListener('click', function () {
        var defaultSceneId = sceneToggle.getAttribute('data-scene-default');
        var contextSceneId = sceneToggle.getAttribute('data-scene-context');
        var targetSceneId = state.scene === contextSceneId ? defaultSceneId : contextSceneId;

        if (sceneToggle.disabled || isCustomizerBusy() || !targetSceneId) {
          return;
        }

        sceneLoadPromise = setScene(targetSceneId);
      });
    }

    var uploadInput = root.querySelector('#TiltImageUpload');

    if (uploadInput) {
      uploadInput.addEventListener('change', handleUploadChange);
    }

    initAddToCartIntegration(root);
    initVariantChangeIntegration();
  }

  function init() {
    var root = document.getElementById(ROOT_ID);

    if (!root) {
      return;
    }

    customizerRoot = root;
    config = parseConfig();

    if (!config) {
      return;
    }

    installTelemetryErrorHandlers();

    if (!window.fabric) {
      console.error('[TiltCustomizer] Fabric.js is not loaded.');
      return;
    }

    uploadStatusElement = root.querySelector('.tilt-customizer__upload-status');
    currentVariant = getCurrentVariant();

    var resolvedTemplate = resolveTemplateForVariant(currentVariant);

    if (!resolvedTemplate) {
      setUnsupportedTemplateState(getUnsupportedTemplateMessage());
      initAddToCartIntegration(root);
      initVariantChangeIntegration();
      return;
    }

    if (!applyTemplate(resolvedTemplate)) {
      initAddToCartIntegration(root);
      initVariantChangeIntegration();
      return;
    }

    canvas = new window.fabric.Canvas(CANVAS_ID, {
      preserveObjectStacking: true,
      selection: false,
      allowTouchScrolling: true
    });
    canvas.setWidth(canvasWidth);
    canvas.setHeight(canvasHeight);
    applyCanvasTouchAction();
    canvas.on('after:render', scheduleGestureOverlaySync);
    canvas.on('object:modified', function (event) {
      if (event && event.target && event.target === state.customerImage) {
        invalidateGeneratedOutputsForTemplateChange();
      }
    });

    sessionId = getOrCreateSessionId();
    bindEvents(root);
    bindCanvasTouchScaling();
    bindMobileCanvasDeselect();
    applyTemplate(resolvedTemplate);
    window.addEventListener('resize', scheduleCanvasDisplaySizeSync);

    window.TiltCustomizer = {
      canvas: canvas,
      exportState: exportState,
      getState: exportState,
      ensureDesign: ensureDesign,
      saveDesignState: saveDesignState,
      requestUploadUrl: requestUploadUrl,
      uploadToStorage: uploadToStorage,
      completeUpload: completeUpload,
      createThumbnailBlob: createThumbnailBlob,
      uploadThumbnail: uploadThumbnail,
      finalizeDesignForCart: finalizeDesignForCart,
      hasStartedPersonalization: hasStartedPersonalization,
      addOrUpdateCustomizerProperties: addOrUpdateCustomizerProperties,
      backendState: backendState
    };
  }

  document.addEventListener('DOMContentLoaded', init);
}());
